/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { GetUserInviteCodeResult } from '../_models/inviteUsers/getUserInviteCodeResult';
import { CreateAccountRequest, ErrorResponse } from '@api/IdentityClient';

export const API_SOCIAL_NETWORK_URL = new InjectionToken<string>('API_SOCIAL_NETWORK_URL');

@Injectable()
export class SocialNetworkClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_SOCIAL_NETWORK_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  /**
   * Get rewards list for current user
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return Success
   */
  airdropRewardsList(pageNumber: number | undefined, pageSize: number | undefined): Observable<AirdropRewardsResult> {
    let url_ = this.baseUrl + "/AirdropRewards/list?";
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAirdropRewardsList(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAirdropRewardsList(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AirdropRewardsResult>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AirdropRewardsResult>;
    }));
  }

  protected processAirdropRewardsList(response: HttpResponseBase): Observable<AirdropRewardsResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AirdropRewardsResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<AirdropRewardsResult>(null as any);
  }

  /**
   * Get wallet's balance
   * @param walletAddress (optional) Wallet hash
   * @param coinType (optional) Coin type
   * @return Success
   */
  getBalance(walletAddress: string | null | undefined, coinType: CoinType | null | undefined): Observable<WalletBalanceQueryResult> {
    let url_ = this.baseUrl + "/BlockChain?";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetBalance(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetBalance(<any>response_);
        } catch (e) {
          return <Observable<WalletBalanceQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<WalletBalanceQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetBalance(response: HttpResponseBase): Observable<WalletBalanceQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WalletBalanceQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<WalletBalanceQueryResult>(<any>null);
  }

  /**
   * Get EthToDollar Stats
   * @return Success
   */
  getEthToDollarStats(): Observable<any> {
    let url_ = this.baseUrl + "/gastracker/price/ethusdt";

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetEthToDollarStats(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetEthToDollarStats(<any>response_);
        } catch (e) {
          return <Observable<any>><any>_observableThrow(e);
        }
      } else
        return <Observable<any>><any>_observableThrow(response_);
    }));
  }

  protected processGetEthToDollarStats(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200;
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<any>(<any>null);
  }


  /**
   * Send transaction
   * @param request (optional)
   * @return Success
   */
  sendTransaction(request: TransactionViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/BlockChain";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSendTransaction(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendTransaction(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processSendTransaction(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get wallet's token balance
   * @param walletAddress (optional) Wallet address
   * @param contractAddress (optional) Contract address
   * @param coinType (optional)
   * @return Success
   */
  getTokenBalance(walletAddress: string | null | undefined, contractAddress: string | null | undefined, coinType: CoinType2 | null | undefined): Observable<WalletTokenBalanceQueryResult> {
    let url_ = this.baseUrl + "/BlockChain/token-balance?";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    if (contractAddress !== undefined)
      url_ += "contractAddress=" + encodeURIComponent("" + contractAddress) + "&";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTokenBalance(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTokenBalance(<any>response_);
        } catch (e) {
          return <Observable<WalletTokenBalanceQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<WalletTokenBalanceQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTokenBalance(response: HttpResponseBase): Observable<WalletTokenBalanceQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WalletTokenBalanceQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<WalletTokenBalanceQueryResult>(<any>null);
  }

  /**
   * Transfer token
   * @param privateKey (optional) Private key
   * @param to (optional) To
   * @param contractAddress (optional) Contract address
   * @param value (optional) Amount
   * @param gasPrice (optional) Gas Price
   * @param decimal (optional) Decimal
   * @return Success
   */
  transfer(privateKey: string | null | undefined, to: string | null | undefined, contractAddress: string | null | undefined, value: number | null | undefined, gasPrice: string | null | undefined, decimal: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/BlockChain/transfer?";
    if (privateKey !== undefined)
      url_ += "privateKey=" + encodeURIComponent("" + privateKey) + "&";
    if (to !== undefined)
      url_ += "to=" + encodeURIComponent("" + to) + "&";
    if (contractAddress !== undefined)
      url_ += "contractAddress=" + encodeURIComponent("" + contractAddress) + "&";
    if (value !== undefined)
      url_ += "value=" + encodeURIComponent("" + value) + "&";
    if (gasPrice !== undefined)
      url_ += "gasPrice=" + encodeURIComponent("" + gasPrice) + "&";
    if (decimal !== undefined)
      url_ += "decimal=" + encodeURIComponent("" + decimal) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processTransfer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processTransfer(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processTransfer(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get token info
   * @param contractAddress (optional)
   * @return Success
   */
  getTokenInfo(contractAddress: string | null | undefined): Observable<TokenInfoQueryResult> {
    let url_ = this.baseUrl + "/BlockChain/token-info?";
    if (contractAddress !== undefined)
      url_ += "contractAddress=" + encodeURIComponent("" + contractAddress) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTokenInfo(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTokenInfo(<any>response_);
        } catch (e) {
          return <Observable<TokenInfoQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TokenInfoQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTokenInfo(response: HttpResponseBase): Observable<TokenInfoQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TokenInfoQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TokenInfoQueryResult>(<any>null);
  }

  /**
   * Get fees for transaction
   * @param coinType (optional) Coin type
   * @param gas (optional) Gas
   * @return Success
   */
  getTransactionFees(coinType: CoinType3 | null | undefined, gas: number | null | undefined): Observable<TransactionFeeQueryResult> {
    let url_ = this.baseUrl + "/BlockChain/transaction-fees?";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    if (gas !== undefined)
      url_ += "gas=" + encodeURIComponent("" + gas) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTransactionFees(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTransactionFees(<any>response_);
        } catch (e) {
          return <Observable<TransactionFeeQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TransactionFeeQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTransactionFees(response: HttpResponseBase): Observable<TransactionFeeQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TransactionFeeQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TransactionFeeQueryResult>(<any>null);
  }

  /**
   * Get fees for transaction
   * @param coinType (optional) Coin type
   * @param addressFrom (optional) Gas
   * @param addressTo (optional) Gas
   * @return Success
   */
  getPreCalculateTransactionFees(coinType: CoinType3 | null | undefined, addressFrom: string | null | undefined,  addressTo: string | null | undefined): Observable<TransactionFeeQueryResult> {
    let url_ = this.baseUrl + "/BlockChain/transaction-fees?";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    if (addressFrom !== undefined)
      url_ += "addressFrom=" + encodeURIComponent("" + addressFrom) + "&";
    if (addressTo !== undefined)
      url_ += "addressTo=" + encodeURIComponent("" + addressTo) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPreCalculateTransactionFees(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPreCalculateTransactionFees(<any>response_);
        } catch (e) {
          return <Observable<TransactionFeeQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TransactionFeeQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetPreCalculateTransactionFees(response: HttpResponseBase): Observable<TransactionFeeQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TransactionFeeQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TransactionFeeQueryResult>(<any>null);
  }

  /**
   * Estimate Gas
   * @param receiverAddress (optional)
   * @param amount (optional)
   * @param gasPrice (optional)
   * @param contractAddress (optional)
   * @return Success
   */
  estimateGas(receiverAddress: string | null | undefined, amount: string | null | undefined, gasPrice: string | null | undefined, contractAddress: string | null | undefined): Observable<SingleQueryResultOfString> {
    let url_ = this.baseUrl + "/BlockChain/estimate-gas?";
    if (receiverAddress !== undefined)
      url_ += "receiverAddress=" + encodeURIComponent("" + receiverAddress) + "&";
    if (amount !== undefined)
      url_ += "amount=" + encodeURIComponent("" + amount) + "&";
    if (gasPrice !== undefined)
      url_ += "gasPrice=" + encodeURIComponent("" + gasPrice) + "&";
    if (contractAddress !== undefined)
      url_ += "contractAddress=" + encodeURIComponent("" + contractAddress) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processEstimateGas(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEstimateGas(<any>response_);
        } catch (e) {
          return <Observable<SingleQueryResultOfString>><any>_observableThrow(e);
        }
      } else
        return <Observable<SingleQueryResultOfString>><any>_observableThrow(response_);
    }));
  }

  protected processEstimateGas(response: HttpResponseBase): Observable<SingleQueryResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SingleQueryResultOfString.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SingleQueryResultOfString>(<any>null);
  }

  /**
   * Get transaction count
   * @param walletAddress (optional)
   * @return Success
   */
  getTransactionCount(walletAddress: string | null | undefined): Observable<TransactionCountQueryResult> {
    let url_ = this.baseUrl + "/BlockChain/transaction-count?";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTransactionCount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTransactionCount(<any>response_);
        } catch (e) {
          return <Observable<TransactionCountQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TransactionCountQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTransactionCount(response: HttpResponseBase): Observable<TransactionCountQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TransactionCountQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TransactionCountQueryResult>(<any>null);
  }

  /**
   * Get cil wallet unspent transactions
   * @param walletAddress (optional) Wallet hash
   * @param coinType (optional) Coin type
   * @return Success
   */
  getWalletListUnspent(walletAddress: string | null | undefined, coinType: CoinType4 | null | undefined): Observable<WalletListUnspentQueryResult> {
    let url_ = this.baseUrl + "/BlockChain/wallet-list-unspent?";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetWalletListUnspent(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWalletListUnspent(<any>response_);
        } catch (e) {
          return <Observable<WalletListUnspentQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<WalletListUnspentQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetWalletListUnspent(response: HttpResponseBase): Observable<WalletListUnspentQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WalletListUnspentQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<WalletListUnspentQueryResult>(<any>null);
  }

  /**
   * Get cil transaction receipt
   * @param transactionHash (optional)
   * @return Success
   */
  getTransactionReceipt(transactionHash: string | null | undefined): Observable<TransactionReceiptQueryResult> {
    let url_ = this.baseUrl + "/BlockChain/transaction-receipt?";
    if (transactionHash !== undefined)
      url_ += "transactionHash=" + encodeURIComponent("" + transactionHash) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTransactionReceipt(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTransactionReceipt(<any>response_);
        } catch (e) {
          return <Observable<TransactionReceiptQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TransactionReceiptQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTransactionReceipt(response: HttpResponseBase): Observable<TransactionReceiptQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TransactionReceiptQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TransactionReceiptQueryResult>(<any>null);
  }

  /**
   * Get params for signing post and comments
   * @return Success
   */
  getSigningParams(): Observable<ForumOptions> {
    let url_ = this.baseUrl + "/BlockChain/signing-params";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetSigningParams(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSigningParams(<any>response_);
        } catch (e) {
          return <Observable<ForumOptions>><any>_observableThrow(e);
        }
      } else
        return <Observable<ForumOptions>><any>_observableThrow(response_);
    }));
  }

  protected processGetSigningParams(response: HttpResponseBase): Observable<ForumOptions> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ForumOptions.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<ForumOptions>(<any>null);
  }

  /**
   * Get comments
   * @param postId (optional) Post id
   * @param profileId (optional) Post id
   * @return Success
   */
  getPostComments(postId: number | null | undefined, profileId: number | null | undefined): Observable<MultipleQueryResultOfCommentDetailDto> {
    let url_ = this.baseUrl + "/Comments?";
    if (postId !== undefined)
      url_ += "postId=" + encodeURIComponent("" + postId) + "&";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPostComments(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPostComments(<any>response_);
        } catch (e) {
          return <Observable<MultipleQueryResultOfCommentDetailDto>><any>_observableThrow(e);
        }
      } else
        return <Observable<MultipleQueryResultOfCommentDetailDto>><any>_observableThrow(response_);
    }));
  }

  protected processGetPostComments(response: HttpResponseBase): Observable<MultipleQueryResultOfCommentDetailDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MultipleQueryResultOfCommentDetailDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<MultipleQueryResultOfCommentDetailDto>(<any>null);
  }

  /**
   * Edit comment
   * @param model (optional) Smart-contract data
   * @return Success
   */
  editComment(model: CommentDetailDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Comments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processEditComment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEditComment(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processEditComment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Create new comment
   * @param model (optional) Smart-contract data
   * @return Success
   */
  createComment(model: CommentDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Comments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateComment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateComment(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processCreateComment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Delete comment
   * @param model (optional) Smart-contract data
   * @return Success
   */
  deleteComment(model: BaseCommentDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Comments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeleteComment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteComment(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processDeleteComment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get consilium list
   * @param profileId (optional) Profile Id
   * @param search (optional) Search by name
   * @param searchType (optional) Search type
   * @return Success
   */
  getConsiliums(profileId: number | null | undefined, search: string | null | undefined, searchType: SearchType | null | undefined): Observable<ConsiliumsResult> {
    let url_ = this.baseUrl + "/Consiliums?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (searchType !== undefined)
      url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetConsiliums(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetConsiliums(<any>response_);
        } catch (e) {
          return <Observable<ConsiliumsResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<ConsiliumsResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetConsiliums(response: HttpResponseBase): Observable<ConsiliumsResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ConsiliumsResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<ConsiliumsResult>(<any>null);
  }

  /**
   * Get consilium details
   * @param profileId (optional)
   * @param contractId (optional)
   * @return Success
   */
  getConsiliumDetails(profileId: number | null | undefined, contractId: number | null | undefined): Observable<ConsiliumDetailResult> {
    let url_ = this.baseUrl + "/Consiliums/details?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (contractId !== undefined)
      url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetConsiliumDetails(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetConsiliumDetails(<any>response_);
        } catch (e) {
          return <Observable<ConsiliumDetailResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<ConsiliumDetailResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetConsiliumDetails(response: HttpResponseBase): Observable<ConsiliumDetailResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ConsiliumDetailResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<ConsiliumDetailResult>(<any>null);
  }

  /**
   * Add consilium to favorite
   * @param model (optional) Consilium data
   * @return Success
   */
  addConsiliumToFavorite(model: AddToFavoriteViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Consiliums/favorite";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddConsiliumToFavorite(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddConsiliumToFavorite(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processAddConsiliumToFavorite(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Remove consilium from favorite
   * @param profileId (optional)
   * @param consiliumId (optional)
   * @return Success
   */
  removeConsiliumFromFavorite(profileId: number | null | undefined, consiliumId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Consiliums/favorite?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (consiliumId !== undefined)
      url_ += "consiliumId=" + encodeURIComponent("" + consiliumId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRemoveConsiliumFromFavorite(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveConsiliumFromFavorite(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRemoveConsiliumFromFavorite(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get total amount of consilium
   * @param address (optional)
   * @return Success
   */
  getTotalAmount(address: string | null | undefined): Observable<ConsiliumTotalAmountResult> {
    let url_ = this.baseUrl + "/Consiliums/total-amount?";
    if (address !== undefined)
      url_ += "address=" + encodeURIComponent("" + address) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTotalAmount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTotalAmount(<any>response_);
        } catch (e) {
          return <Observable<ConsiliumTotalAmountResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<ConsiliumTotalAmountResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTotalAmount(response: HttpResponseBase): Observable<ConsiliumTotalAmountResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ConsiliumTotalAmountResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<ConsiliumTotalAmountResult>(<any>null);
  }

  /**
   * Get last block
   * @param conciliumId (optional)
   * @return Success
   */
  getLastBlock(conciliumId: number | null | undefined): Observable<LastBlockResult> {
    let url_ = this.baseUrl + "/Consiliums/last-block?";
    if (conciliumId !== undefined)
      url_ += "conciliumId=" + encodeURIComponent("" + conciliumId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetLastBlock(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLastBlock(<any>response_);
        } catch (e) {
          return <Observable<LastBlockResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<LastBlockResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetLastBlock(response: HttpResponseBase): Observable<LastBlockResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LastBlockResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<LastBlockResult>(<any>null);
  }

  /**
   * Get participants profile ids
   * @param address (optional)
   * @return Success
   */
  getParticipantsProfileIds(address: string | null | undefined): Observable<ParticipantsProfileIdsResult> {
    let url_ = this.baseUrl + "/Consiliums/participants-ids?";
    if (address !== undefined)
      url_ += "address=" + encodeURIComponent("" + address) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetParticipantsProfileIds(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetParticipantsProfileIds(<any>response_);
        } catch (e) {
          return <Observable<ParticipantsProfileIdsResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<ParticipantsProfileIdsResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetParticipantsProfileIds(response: HttpResponseBase): Observable<ParticipantsProfileIdsResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ParticipantsProfileIdsResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<ParticipantsProfileIdsResult>(<any>null);
  }

  /**
   * Get feed
   * @param profileId (optional)
   * @param oracleIds (optional)
   * @param postSearchType (optional)
   * @param pageNumber (optional) Page number (optional)
   * @param pageSize (optional) Page size(optional)
   * @return Success
   */
  getFeed(profileId: number | null | undefined, oracleIds: number[] | null | undefined, postSearchType: PostSearchType | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<MultipleQueryResultOfPostDetailDto> {
    let url_ = this.baseUrl + "/Feeds?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (oracleIds !== undefined)
      oracleIds && oracleIds.forEach(item => { url_ += "oracleIds=" + encodeURIComponent("" + item) + "&"; });
    if (postSearchType !== undefined)
      url_ += "postSearchType=" + encodeURIComponent("" + postSearchType) + "&";
    if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetFeed(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetFeed(<any>response_);
        } catch (e) {
          return <Observable<MultipleQueryResultOfPostDetailDto>><any>_observableThrow(e);
        }
      } else
        return <Observable<MultipleQueryResultOfPostDetailDto>><any>_observableThrow(response_);
    }));
  }

  protected processGetFeed(response: HttpResponseBase): Observable<MultipleQueryResultOfPostDetailDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MultipleQueryResultOfPostDetailDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<MultipleQueryResultOfPostDetailDto>(<any>null);
  }

  /**
   * Get file
   * @param fileName (optional) file id
   * @return Success
   */
  getFile(fileName: string | null | undefined): Observable<string> {
    let url_ = this.baseUrl + "/Files?";
    if (fileName !== undefined)
      url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetFile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetFile(<any>response_);
        } catch (e) {
          return <Observable<string>><any>_observableThrow(e);
        }
      } else
        return <Observable<string>><any>_observableThrow(response_);
    }));
  }

  protected processGetFile(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MiddlewareExceptionWrapper.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Upload avatar
   * @param request (optional)
   * @return Success
   */
  createFile(request: UploadFileRequest | null | undefined): Observable<string> {
    let url_ = this.baseUrl + "/Files";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateFile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateFile(<any>response_);
        } catch (e) {
          return <Observable<string>><any>_observableThrow(e);
        }
      } else
        return <Observable<string>><any>_observableThrow(response_);
    }));
  }

  protected processCreateFile(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MiddlewareExceptionWrapper.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Upload video
   * @param file (optional) Form file
   * @return Success
   */
  createVideo(file: FileParameter | null | undefined): Observable<string> {
    let url_ = this.baseUrl + "/Files/video";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateVideo(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateVideo(<any>response_);
        } catch (e) {
          return <Observable<string>><any>_observableThrow(e);
        }
      } else
        return <Observable<string>><any>_observableThrow(response_);
    }));
  }

  protected processCreateVideo(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MiddlewareExceptionWrapper.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Get games
   * @param profileId (optional) Profile Id
   * @param search (optional) Search by name
   * @param gameSearchType (optional) Search type
   * @return Success
   */
  getGames(profileId: number | null | undefined, search: string | null | undefined, gameSearchType: GameSearchType | null | undefined): Observable<GamesResult> {
    let url_ = this.baseUrl + "/Games?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (gameSearchType !== undefined)
      url_ += "gameSearchType=" + encodeURIComponent("" + gameSearchType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetGames(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetGames(<any>response_);
        } catch (e) {
          return <Observable<GamesResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<GamesResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetGames(response: HttpResponseBase): Observable<GamesResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GamesResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<GamesResult>(<any>null);
  }

  /**
   * Get game details
   * @param profileId (optional)
   * @param gameId (optional)
   * @return Success
   */
  getGameDetails(profileId: number | null | undefined, gameId: number | null | undefined): Observable<GameDetailResult> {
    let url_ = this.baseUrl + "/Games/details?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (gameId !== undefined)
      url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetGameDetails(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetGameDetails(<any>response_);
        } catch (e) {
          return <Observable<GameDetailResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<GameDetailResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetGameDetails(response: HttpResponseBase): Observable<GameDetailResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GameDetailResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<GameDetailResult>(<any>null);
  }

  /**
   * Get game players
   * @param profileId (optional)
   * @param gameId (optional)
   * @return Success
   */
  getGamePlayers(profileId: number | null | undefined, gameId: number | null | undefined): Observable<GamePlayersResult> {
    let url_ = this.baseUrl + "/Games/players?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (gameId !== undefined)
      url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetGamePlayers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetGamePlayers(<any>response_);
        } catch (e) {
          return <Observable<GamePlayersResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<GamePlayersResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetGamePlayers(response: HttpResponseBase): Observable<GamePlayersResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GamePlayersResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<GamePlayersResult>(<any>null);
  }

  /**
   * Get chart data
   * @param ticker (optional)
   * @param dateFrom (optional)
   * @param dateTo (optional)
   * @return Success
   */
  getChartData(ticker: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined): Observable<ChartDataQueryResult> {
    let url_ = this.baseUrl + "/Games/chart-data?";
    if (ticker !== undefined)
      url_ += "ticker=" + encodeURIComponent("" + ticker) + "&";
    if (dateFrom !== undefined)
      url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
    if (dateTo !== undefined)
      url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetChartData(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetChartData(<any>response_);
        } catch (e) {
          return <Observable<ChartDataQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<ChartDataQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetChartData(response: HttpResponseBase): Observable<ChartDataQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ChartDataQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<ChartDataQueryResult>(<any>null);
  }

  /**
   * Get player balance
   * @param profileId (optional)
   * @param gameId (optional)
   * @return Success
   */
  getProfileBalance(profileId: number | null | undefined, gameId: number | null | undefined): Observable<GamePlayersModel> {
    let url_ = this.baseUrl + "/Games/balance?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (gameId !== undefined)
      url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetProfileBalance(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfileBalance(<any>response_);
        } catch (e) {
          return <Observable<GamePlayersModel>><any>_observableThrow(e);
        }
      } else
        return <Observable<GamePlayersModel>><any>_observableThrow(response_);
    }));
  }

  protected processGetProfileBalance(response: HttpResponseBase): Observable<GamePlayersModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GamePlayersModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<GamePlayersModel>(<any>null);
  }

  /**
   * Get players rating
   * @param gameId (optional)
   * @return Success
   */
  getRating(gameId: number | null | undefined): Observable<RatingResult> {
    let url_ = this.baseUrl + "/Games/rating?";
    if (gameId !== undefined)
      url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetRating(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRating(<any>response_);
        } catch (e) {
          return <Observable<RatingResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<RatingResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetRating(response: HttpResponseBase): Observable<RatingResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RatingResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<RatingResult>(<any>null);
  }

  /**
   * Get trade history
   * @param gameId (optional)
   * @return Success
   */
  getTradeHistory(gameId: number | null | undefined): Observable<TradeHistoryResult> {
    let url_ = this.baseUrl + "/Games/trade-history?";
    if (gameId !== undefined)
      url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTradeHistory(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTradeHistory(<any>response_);
        } catch (e) {
          return <Observable<TradeHistoryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TradeHistoryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTradeHistory(response: HttpResponseBase): Observable<TradeHistoryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TradeHistoryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TradeHistoryResult>(<any>null);
  }

  /**
   * Like post resource
   * @param model (optional) like model
   * @return Success
   */
  likePost(model: PostLikeRequest | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Likes/post";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processLikePost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLikePost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processLikePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Like comment resource
   * @param model (optional) like model
   * @return Success
   */
  likeComment(model: CommentLikeRequest | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Likes/comment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processLikeComment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLikeComment(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processLikeComment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Edit post
   * @param model (optional)
   * @return Success
   */
  editPost(model: PostDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Posts";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processEditPost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEditPost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processEditPost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Create new post
   * @param model (optional)
   * @return Success
   */
  createPost(model: PostDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Posts";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreatePost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreatePost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processCreatePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Remove post
   * @param id (optional)
   * @param pId (optional)
   * @return Success
   */
  removePost(id: number | null | undefined, pId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Posts?";
    if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (pId !== undefined)
      url_ += "pId=" + encodeURIComponent("" + pId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRemovePost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemovePost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRemovePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get post
   * @param postId (optional)
   * @param profileId (optional)
   * @return Success
   */
  getPost(postId: number | null | undefined, profileId: number | null | undefined): Observable<SingleQueryResultOfPostDetailDto> {
    let url_ = this.baseUrl + "/Posts/full?";
    if (postId !== undefined)
      url_ += "postId=" + encodeURIComponent("" + postId) + "&";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPost(<any>response_);
        } catch (e) {
          return <Observable<SingleQueryResultOfPostDetailDto>><any>_observableThrow(e);
        }
      } else
        return <Observable<SingleQueryResultOfPostDetailDto>><any>_observableThrow(response_);
    }));
  }

  protected processGetPost(response: HttpResponseBase): Observable<SingleQueryResultOfPostDetailDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SingleQueryResultOfPostDetailDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SingleQueryResultOfPostDetailDto>(<any>null);
  }

  /**
   * Get post
   * @param postDisplayId (optional)
   * @param profileId (optional)
   * @return Success
   */
  getPostByDisplayId(postDisplayId: string | null | undefined, profileId: number | null | undefined): Observable<SingleQueryResultOfPostDetailDto> {
    let url_ = this.baseUrl + "/Posts/full-by-displayid?";
    if (postDisplayId !== undefined)
      url_ += "postDisplayId=" + encodeURIComponent("" + postDisplayId) + "&";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPostByDisplayId(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPostByDisplayId(<any>response_);
        } catch (e) {
          return <Observable<SingleQueryResultOfPostDetailDto>><any>_observableThrow(e);
        }
      } else
        return <Observable<SingleQueryResultOfPostDetailDto>><any>_observableThrow(response_);
    }));
  }

  protected processGetPostByDisplayId(response: HttpResponseBase): Observable<SingleQueryResultOfPostDetailDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SingleQueryResultOfPostDetailDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SingleQueryResultOfPostDetailDto>(<any>null);
  }

  /**
   * togle archive post
   * @param model (optional)
   * @return Success
   */
  toggleArchivePost(model: ProfilePostViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Posts/toggle-archive";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processToggleArchivePost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processToggleArchivePost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processToggleArchivePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Hide post
   * @param model (optional)
   * @return Success
   */
  hidePost(model: ProfilePostViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Posts/hide";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processHidePost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHidePost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processHidePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Sign post
   * @param model (optional)
   * @return Success
   */
  signPost(model: ProfilePostWithWalletAddressViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Posts/sign";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSignPost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSignPost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processSignPost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  remove(id: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Posts/action?";
    if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRemove(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemove(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRemove(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get sandboxes
   * @param pageNumber (optional) Page number (optional)
   * @param pageSize (optional) Page size(optional)
   * @return Success
   */
  getSandboxes(pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<MultipleQueryResultOfSandboxDto> {
    let url_ = this.baseUrl + "/Sandbox?";
    if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetSandboxes(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSandboxes(<any>response_);
        } catch (e) {
          return <Observable<MultipleQueryResultOfSandboxDto>><any>_observableThrow(e);
        }
      } else
        return <Observable<MultipleQueryResultOfSandboxDto>><any>_observableThrow(response_);
    }));
  }

  protected processGetSandboxes(response: HttpResponseBase): Observable<MultipleQueryResultOfSandboxDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MultipleQueryResultOfSandboxDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<MultipleQueryResultOfSandboxDto>(<any>null);
  }

  /**
   * Edit sandbox
   * @param model (optional)
   * @return Success
   */
  editSandbox(model: SandboxDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Sandbox";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processEditSandbox(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEditSandbox(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processEditSandbox(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Create new sandbox
   * @param model (optional)
   * @return Success
   */
  createSandbox(model: SandboxDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Sandbox";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateSandbox(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateSandbox(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processCreateSandbox(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Remove sandbox
   * @param id (optional)
   * @return Success
   */
  removeSandbox(id: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Sandbox?";
    if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRemoveSandbox(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveSandbox(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRemoveSandbox(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get sandbox
   * @return Success
   */
  getSandbox(sandboxId: number): Observable<SingleQueryResultOfSandboxDto> {
    let url_ = this.baseUrl + "/Sandbox/{sandboxId}";
    if (sandboxId === undefined || sandboxId === null)
      throw new Error("The parameter 'sandboxId' must be defined.");
    url_ = url_.replace("{sandboxId}", encodeURIComponent("" + sandboxId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetSandbox(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSandbox(<any>response_);
        } catch (e) {
          return <Observable<SingleQueryResultOfSandboxDto>><any>_observableThrow(e);
        }
      } else
        return <Observable<SingleQueryResultOfSandboxDto>><any>_observableThrow(response_);
    }));
  }

  protected processGetSandbox(response: HttpResponseBase): Observable<SingleQueryResultOfSandboxDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SingleQueryResultOfSandboxDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SingleQueryResultOfSandboxDto>(<any>null);
  }

  /**
   * Remove attachment
   * @param sandboxId (optional)
   * @param attachmentId (optional)
   * @return Success
   */
  removeAttachment(sandboxId: number | null | undefined, attachmentId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Sandbox/attachment?";
    if (sandboxId !== undefined)
      url_ += "sandboxId=" + encodeURIComponent("" + sandboxId) + "&";
    if (attachmentId !== undefined)
      url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRemoveAttachment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveAttachment(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRemoveAttachment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Sharing information
   * @return Success
   */
  sharePost(encodedString: string): Observable<void> {
    let url_ = this.baseUrl + "/Share/{encodedString}";
    if (encodedString === undefined || encodedString === null)
      throw new Error("The parameter 'encodedString' must be defined.");
    url_ = url_.replace("{encodedString}", encodeURIComponent("" + encodedString));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSharePost(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSharePost(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processSharePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Sharing information
   * @return Success
   */
  shareSandbox(encodedString: string): Observable<void> {
    let url_ = this.baseUrl + "/Share/sandbox/{encodedString}";
    if (encodedString === undefined || encodedString === null)
      throw new Error("The parameter 'encodedString' must be defined.");
    url_ = url_.replace("{encodedString}", encodeURIComponent("" + encodedString));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processShareSandbox(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processShareSandbox(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processShareSandbox(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get smart-contracts
   * @param profileId (optional) Profile Id
   * @param search (optional) Search by name
   * @param searchType (optional) Search type
   * @return Success
   */
  getSmartContracts(profileId: number | null | undefined, search: string | null | undefined, searchType: SearchType2 | null | undefined): Observable<SmartContractsResult> {
    let url_ = this.baseUrl + "/SmartContracts?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (searchType !== undefined)
      url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetSmartContracts(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSmartContracts(<any>response_);
        } catch (e) {
          return <Observable<SmartContractsResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<SmartContractsResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetSmartContracts(response: HttpResponseBase): Observable<SmartContractsResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SmartContractsResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SmartContractsResult>(<any>null);
  }

  /**
   * Update smart-contract
   * @param model (optional) Smart-contract data
   * @return Success
   */
  updateSmartContract(model: SmartContractDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/SmartContracts";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUpdateSmartContract(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateSmartContract(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processUpdateSmartContract(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Add smart-contract
   * @param model (optional) Smart-contract data
   * @return Success
   */
  addSmartContract(model: SmartContractViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/SmartContracts";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddSmartContract(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddSmartContract(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processAddSmartContract(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Remove smart-contract
   * @param smartContractId (optional)
   * @return Success
   */
  removeSmartContract(smartContractId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/SmartContracts?";
    if (smartContractId !== undefined)
      url_ += "smartContractId=" + encodeURIComponent("" + smartContractId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRemoveSmartContract(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveSmartContract(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRemoveSmartContract(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get smart-contract details
   * @param profileId (optional)
   * @param contractId (optional)
   * @return Success
   */
  getSmartContractDetails(profileId: number | null | undefined, contractId: number | null | undefined): Observable<SmartContractDetailResult> {
    let url_ = this.baseUrl + "/SmartContracts/details?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (contractId !== undefined)
      url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetSmartContractDetails(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSmartContractDetails(<any>response_);
        } catch (e) {
          return <Observable<SmartContractDetailResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<SmartContractDetailResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetSmartContractDetails(response: HttpResponseBase): Observable<SmartContractDetailResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SmartContractDetailResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SmartContractDetailResult>(<any>null);
  }

  /**
   * Add smart-contract to favorite
   * @param model (optional) Smart-contract data
   * @return Success
   */
  addSmartContractToFavorite(model: AddToFavoriteViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/SmartContracts/favorite";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddSmartContractToFavorite(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddSmartContractToFavorite(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processAddSmartContractToFavorite(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Remove smart-contract from favorite
   * @param profileId (optional)
   * @param smartContractId (optional)
   * @return Success
   */
  removeSmartContractFromFavorite(profileId: number | null | undefined, smartContractId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/SmartContracts/favorite?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (smartContractId !== undefined)
      url_ += "smartContractId=" + encodeURIComponent("" + smartContractId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRemoveSmartContractFromFavorite(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRemoveSmartContractFromFavorite(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRemoveSmartContractFromFavorite(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get transaction status
   * @param transitWallet (optional)
   * @param pref (optional)
   * @param tokenSymbol (optional)
   * @return Success
   */
  status(transitWallet: string | null | undefined): Observable<WalletSwapStatusQueryResult> {
    let url_ = this.baseUrl + "/Swap?";
    if (transitWallet !== undefined)
      url_ += "transitWallet=" + encodeURIComponent("" + transitWallet) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processStatus(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processStatus(<any>response_);
        } catch (e) {
          return <Observable<WalletSwapStatusQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<WalletSwapStatusQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processStatus(response: HttpResponseBase): Observable<WalletSwapStatusQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WalletSwapStatusQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<WalletSwapStatusQueryResult>(<any>null);
  }

  /**
   * Prepare transaction
   * @param walletId (optional)
   * @param coinFrom (optional)
   * @param symbolFrom (optional)
   * @param coinTo (optional)
   * @param symbolTo (optional)
   * @return Success
   */
  prepare(walletId: number | null | undefined,
          coinFrom: string | null | undefined, symbolFrom: string | null | undefined,
          coinTo: string | null | undefined, symbolTo: string | null | undefined): Observable<WalletSwapStatusQueryResult> {
    let url_ = this.baseUrl + "/Swap?";
    if (walletId !== undefined)
      url_ += "walletId=" + encodeURIComponent("" + walletId) + "&";
    if (coinFrom !== undefined)
      url_ += "coinFrom=" + encodeURIComponent("" + coinFrom) + "&";
    if (symbolFrom !== undefined)
      url_ += "symbolFrom=" + encodeURIComponent("" + symbolFrom) + "&";
    if (coinTo !== undefined)
      url_ += "coinTo=" + encodeURIComponent("" + coinTo) + "&";
    if (symbolTo !== undefined)
      url_ += "symbolTo=" + encodeURIComponent("" + symbolTo) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processPrepare(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPrepare(<any>response_);
        } catch (e) {
          return <Observable<WalletSwapStatusQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<WalletSwapStatusQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processPrepare(response: HttpResponseBase): Observable<WalletSwapStatusQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WalletSwapStatusQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<WalletSwapStatusQueryResult>(<any>null);
  }

  /**
   * Get transit wallet
   * @param walletAddress (optional)
   * @param coinFrom (optional)
   * @param symbolFrom (optional)
   * @param coinTo (optional)
   * @param symbolTo (optional)
   * @return Success
   */
  getTransitWallet(walletAddress: string | null | undefined, coinFrom: string | null | undefined, symbolFrom: string | null | undefined,
                   coinTo: string | null | undefined, symbolTo: string | null | undefined): Observable<string> {
    let url_ = this.baseUrl + "/Swap/transit-wallet?";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    if (coinFrom !== undefined)
      url_ += "coinFrom=" + encodeURIComponent("" + coinFrom) + "&";
    if (symbolFrom !== undefined)
      url_ += "symbolFrom=" + encodeURIComponent("" + symbolFrom) + "&";
    if (coinTo !== undefined)
      url_ += "coinTo=" + encodeURIComponent("" + coinTo) + "&";
    if (symbolTo !== undefined)
      url_ += "symbolTo=" + encodeURIComponent("" + symbolTo) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTransitWallet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTransitWallet(<any>response_);
        } catch (e) {
          return <Observable<string>><any>_observableThrow(e);
        }
      } else
        return <Observable<string>><any>_observableThrow(response_);
    }));
  }

  protected processGetTransitWallet(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Get transaction status
   * @param transitWallet (optional)
   * @param pref (optional)
   * @param tokenSymbol (optional)
   * @return Success
   */
  statusWithoutWallet(transitWallet: string | null | undefined, pref: Pref4 | null | undefined, tokenSymbol: string | null | undefined): Observable<WalletSwapStatusQueryResult> {
    let url_ = this.baseUrl + "/Swap/status?";
    if (transitWallet !== undefined)
      url_ += "transitWallet=" + encodeURIComponent("" + transitWallet) + "&";
    if (pref !== undefined)
      url_ += "pref=" + encodeURIComponent("" + pref) + "&";
    if (tokenSymbol !== undefined)
      url_ += "tokenSymbol=" + encodeURIComponent("" + tokenSymbol) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processStatusWithoutWallet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processStatusWithoutWallet(<any>response_);
        } catch (e) {
          return <Observable<WalletSwapStatusQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<WalletSwapStatusQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processStatusWithoutWallet(response: HttpResponseBase): Observable<WalletSwapStatusQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WalletSwapStatusQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<WalletSwapStatusQueryResult>(<any>null);
  }

  /**
   * Get swap rate
   * @param coinFrom (optional)
   * @param symbolFrom (optional)
   * @param coinTo (optional)
   * @param symbolTo (optional)
   * @return Success
   */
  getSwapRate(coinFrom: string | null | undefined, symbolFrom: string | null | undefined,
              coinTo: string | null | undefined, symbolTo: string | null | undefined): Observable<SwapRateResult> {
    let url_ = this.baseUrl + "/Swap/rate?";
    if (coinFrom !== undefined)
      url_ += "coinFrom=" + encodeURIComponent("" + coinFrom) + "&";
    if (symbolFrom !== undefined)
      url_ += "symbolFrom=" + encodeURIComponent("" + symbolFrom) + "&";
    if (coinTo !== undefined)
      url_ += "coinTo=" + encodeURIComponent("" + coinTo) + "&";
    if (symbolTo !== undefined)
      url_ += "symbolTo=" + encodeURIComponent("" + symbolTo) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetSwapRate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSwapRate(<any>response_);
        } catch (e) {
          return <Observable<SwapRateResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<SwapRateResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetSwapRate(response: HttpResponseBase): Observable<SwapRateResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SwapRateResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SwapRateResult>(<any>null);
  }

  /**
   * Check swap address for wallet
   * @param transitWallet
   * @return Success
   */
  checkSwapAddress(transitWallet: string): Observable<CheckSwapAddressResult> {
    let url_ = this.baseUrl + "/Swap/check?";
    if (transitWallet !== undefined)
      url_ += "transitWallet=" + encodeURIComponent("" + transitWallet) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCheckSwapAddress(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCheckSwapAddress(<any>response_);
        } catch (e) {
          return <Observable<CheckSwapAddressResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<CheckSwapAddressResult>><any>_observableThrow(response_);
    }));
  }

  protected processCheckSwapAddress(response: HttpResponseBase): Observable<CheckSwapAddressResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CheckSwapAddressResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<CheckSwapAddressResult>(<any>null);
  }

  /**
   * Get pair overview
   * @param pairId (optional)
   * @return Success
   */
  getPairOverview(pairId: string | null | undefined): Observable<UniswapResult> {
    let url_ = this.baseUrl + "/Swap/pair-overview?";
    if (pairId !== undefined)
      url_ += "pairId=" + encodeURIComponent("" + pairId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPairOverview(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPairOverview(<any>response_);
        } catch (e) {
          return <Observable<UniswapResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<UniswapResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetPairOverview(response: HttpResponseBase): Observable<UniswapResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UniswapResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<UniswapResult>(<any>null);
  }

  /**
   * Get the list of profile tokens.
   * @param profileId (optional) Profile id
   * @return Success
   */
  getProfileTokens(profileId: number | null | undefined): Observable<MultipleQueryResultOfTokenQueryResult> {
    let url_ = this.baseUrl + "/Tokens/profile-tokens?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetProfileTokens(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfileTokens(<any>response_);
        } catch (e) {
          return <Observable<MultipleQueryResultOfTokenQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<MultipleQueryResultOfTokenQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetProfileTokens(response: HttpResponseBase): Observable<MultipleQueryResultOfTokenQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MultipleQueryResultOfTokenQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<MultipleQueryResultOfTokenQueryResult>(<any>null);
  }

  getAllWalletTokens(walletAddress: string | null | undefined, coinType: CoinType5 | null | undefined) : Observable<any>
  {
    let url_ = this.baseUrl + "/Tokens/all-wallet-tokens?";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType);

    return this.http.get(url_);
  }

  getAllSandboxes(){
    //let url = this.baseUrl + "/sandbox";
    //https://stage20021.ubikiri.com/api/Sandbox?pageNumber=1&pageSize=50
    let url = this.baseUrl + "/sandbox?pageNumber=1&pageSize=50";
    return this.http.get(url);
  }

  /**
   * Get the list of wallet tokens.
   * @param walletAddress (optional) Wallet id
   * @param coinType (optional) Coin Type
   * @param pageNumber (optional) Pahe number (optional)
   * @param pageSize (optional) Page size(optional)
   * @return Success
   */
  getWalletTokens(walletAddress: string | null | undefined, coinType: CoinType5 | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<MetaQueryResultOfTokenQueryResult> {
    // this.getAllWalletTokens(walletAddress, coinType);

    let url_ = this.baseUrl + "/Tokens/wallet-tokens?";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetWalletTokens(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWalletTokens(<any>response_);
        } catch (e) {
          return <Observable<MetaQueryResultOfTokenQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<MetaQueryResultOfTokenQueryResult>><any>_observableThrow(response_);
    }));
  }

    /**
   * Get the swap paris variants
   * @return Success
   */
     getSwapPairs() {
      let url_ = this.baseUrl + "/swap/pairs";
      return this.http.get(url_);
    }

  protected processGetWalletTokens(response: HttpResponseBase): Observable<MetaQueryResultOfTokenQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MetaQueryResultOfTokenQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<MetaQueryResultOfTokenQueryResult>(<any>null);
  }

  /**
   * Get the user's token by id.
   * @return Success
   */
  getTokenById(tokenId: number): Observable<SingleQueryResultOfToken> {
    let url_ = this.baseUrl + "/Tokens/{tokenId}";
    if (tokenId === undefined || tokenId === null)
      throw new Error("The parameter 'tokenId' must be defined.");
    url_ = url_.replace("{tokenId}", encodeURIComponent("" + tokenId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTokenById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTokenById(<any>response_);
        } catch (e) {
          return <Observable<SingleQueryResultOfToken>><any>_observableThrow(e);
        }
      } else
        return <Observable<SingleQueryResultOfToken>><any>_observableThrow(response_);
    }));
  }

  protected processGetTokenById(response: HttpResponseBase): Observable<SingleQueryResultOfToken> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SingleQueryResultOfToken.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SingleQueryResultOfToken>(<any>null);
  }

  /**
   * Get the user's token
   * @param symbol (optional)
   * @param walletAddress (optional)
   * @param coinType (optional)
   * @return Success
   */
  getTokenBySymbol(symbol: string | null | undefined, walletAddress: string | null | undefined, coinType: CoinType6 | null | undefined): Observable<TokenDetailResult> {
    let url_ = this.baseUrl + "/Tokens/token-by-symbol?";
    if (symbol !== undefined)
      url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
    if (walletAddress !== undefined)
      url_ += "walletAddress=" + encodeURIComponent("" + walletAddress) + "&";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTokenBySymbol(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTokenBySymbol(<any>response_);
        } catch (e) {
          return <Observable<TokenDetailResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TokenDetailResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTokenBySymbol(response: HttpResponseBase): Observable<TokenDetailResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TokenDetailResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TokenDetailResult>(<any>null);
  }

  /**
   * Change display status token
   * @param request (optional)
   * @return Success
   */
  changeDisplayStatusToken(request: ChangeDisplayStatusTokenViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Tokens";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processChangeDisplayStatusToken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeDisplayStatusToken(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processChangeDisplayStatusToken(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Create new token
   * @param request (optional) Token data
   * @return Success
   */
  createToken(request: TokenViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Tokens";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateToken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateToken(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processCreateToken(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Check token exist.
   * @param profileId (optional) Profile id
   * @param walletId (optional) Wallet id
   * @param contractAddress (optional) New contract address
   * @return Success
   */
  checkTokenExist(profileId: number | null | undefined, walletId: number | null | undefined, contractAddress: string | null | undefined): Observable<CheckTokenNameQueryResult> {
    let url_ = this.baseUrl + "/Tokens/check-exist?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (walletId !== undefined)
      url_ += "walletId=" + encodeURIComponent("" + walletId) + "&";
    if (contractAddress !== undefined)
      url_ += "contractAddress=" + encodeURIComponent("" + contractAddress) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCheckTokenExist(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCheckTokenExist(<any>response_);
        } catch (e) {
          return <Observable<CheckTokenNameQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<CheckTokenNameQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processCheckTokenExist(response: HttpResponseBase): Observable<CheckTokenNameQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CheckTokenNameQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<CheckTokenNameQueryResult>(<any>null);
  }

  /**
   * Get token holders
   * @param symbol (optional)
   * @param coinType (optional)
   * @return Success
   */
  getTokenHolders(symbol: string | null | undefined, coinType: CoinType7 | null | undefined): Observable<TokenHoldersResult> {
    let url_ = this.baseUrl + "/Tokens/token-holders?";
    if (symbol !== undefined)
      url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
    if (coinType !== undefined)
      url_ += "coinType=" + encodeURIComponent("" + coinType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTokenHolders(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTokenHolders(<any>response_);
        } catch (e) {
          return <Observable<TokenHoldersResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<TokenHoldersResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetTokenHolders(response: HttpResponseBase): Observable<TokenHoldersResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TokenHoldersResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<TokenHoldersResult>(<any>null);
  }

  /**
   * Get the list of profile wallets.
   * @param profileId (optional) Profile id
   * @param exceptCoinTypes (optional) Coint types
   * @return Success
   */
  getProfileWallets(profileId: number | null | undefined, exceptCoinTypes: ExceptCoinTypes[] | null | undefined): Observable<MultipleQueryResultOfWalletQueryResult> {
    let url_ = this.baseUrl + "/Wallets?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (exceptCoinTypes !== undefined)
      exceptCoinTypes && exceptCoinTypes.forEach(item => { url_ += "exceptCoinTypes=" + encodeURIComponent("" + item) + "&"; });
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetProfileWallets(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProfileWallets(<any>response_);
        } catch (e) {
          return <Observable<MultipleQueryResultOfWalletQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<MultipleQueryResultOfWalletQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetProfileWallets(response: HttpResponseBase): Observable<MultipleQueryResultOfWalletQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MultipleQueryResultOfWalletQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<MultipleQueryResultOfWalletQueryResult>(<any>null);
  }

  /**
   * Change display status wallet
   * @param request (optional)
   * @return Success
   */
  changeDisplayStatusWallet(request: ChangeDisplayStatusWalletViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Wallets";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processChangeDisplayStatusWallet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeDisplayStatusWallet(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processChangeDisplayStatusWallet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Create new wallet
   * @param request (optional) Wallet data
   * @return Success
   */
  createWallet(request: WalletViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Wallets";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateWallet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateWallet(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processCreateWallet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Forget wallet
   * @param walletId (optional)
   * @return Success
   */
  forgetWallet(walletId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Wallets?";
    if (walletId !== undefined)
      url_ += "walletId=" + encodeURIComponent("" + walletId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processForgetWallet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processForgetWallet(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processForgetWallet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get the user's wallet by id.
   * @return Success
   */
  getWalletById(walletId: number): Observable<SingleQueryResultOfWallet> {
    let url_ = this.baseUrl + "/Wallets/{walletId}";
    if (walletId === undefined || walletId === null)
      throw new Error("The parameter 'walletId' must be defined.");
    url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetWalletById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWalletById(<any>response_);
        } catch (e) {
          return <Observable<SingleQueryResultOfWallet>><any>_observableThrow(e);
        }
      } else
        return <Observable<SingleQueryResultOfWallet>><any>_observableThrow(response_);
    }));
  }

  protected processGetWalletById(response: HttpResponseBase): Observable<SingleQueryResultOfWallet> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SingleQueryResultOfWallet.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<SingleQueryResultOfWallet>(<any>null);
  }

  /**
   * Get next wallet number
   * @param profileId (optional)
   * @return Success
   */
  getNextWalletNumber(profileId: number | null | undefined): Observable<NextWalletNumberQueryResult> {
    let url_ = this.baseUrl + "/Wallets/next-wallet-number?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetNextWalletNumber(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetNextWalletNumber(<any>response_);
        } catch (e) {
          return <Observable<NextWalletNumberQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<NextWalletNumberQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetNextWalletNumber(response: HttpResponseBase): Observable<NextWalletNumberQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = NextWalletNumberQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<NextWalletNumberQueryResult>(<any>null);
  }

  /**
   * Check wallet name.
   * @param profileId (optional) Profile id
   * @param walletName (optional) New name
   * @return Success
   */
  checkWalletName(profileId: number | null | undefined, walletName: string | null | undefined): Observable<CheckWalletNameQueryResult> {
    let url_ = this.baseUrl + "/Wallets/check-name?";
    if (profileId !== undefined)
      url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
    if (walletName !== undefined)
      url_ += "walletName=" + encodeURIComponent("" + walletName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCheckWalletName(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCheckWalletName(<any>response_);
        } catch (e) {
          return <Observable<CheckWalletNameQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<CheckWalletNameQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processCheckWalletName(response: HttpResponseBase): Observable<CheckWalletNameQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CheckWalletNameQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<CheckWalletNameQueryResult>(<any>null);
  }

  /**
   * Rename wallet
   * @param request (optional) Wallet data
   * @return Success
   */
  renameWallet(request: RenameWalletRequest | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Wallets/rename";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRenameWallet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRenameWallet(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRenameWallet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get IDL wallets by profileIds
   * @param profileIds (optional)
   * @return Success
   */
  getLawWalletsByProfileIds(profileIds: string | null | undefined): Observable<LawWalletsListQueryResult> {
    let url_ = this.baseUrl + "/Wallets/law-wallets?";
    if (profileIds !== undefined)
      url_ += "profileIds=" + encodeURIComponent("" + profileIds) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetLawWalletsByProfileIds(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLawWalletsByProfileIds(<any>response_);
        } catch (e) {
          return <Observable<LawWalletsListQueryResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<LawWalletsListQueryResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetLawWalletsByProfileIds(response: HttpResponseBase): Observable<LawWalletsListQueryResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LawWalletsListQueryResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error. " + _responseText, status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<LawWalletsListQueryResult>(<any>null);
  }

  /**
   * Create wallet key
   * @param model (optional) key store
   * @return Success
   */
  createWalletKey(model: WalletKeyViewModel | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/Wallets/wallet-key";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateWalletKey(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateWalletKey(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processCreateWalletKey(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = MiddlewareExceptionWrapper.fromJS(resultData500);
        return throwException("Server Error. " + _responseText, status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * Get invite code for current user
   * @return Success
   */
  getInviteCode(): Observable<GetUserInviteCodeResult> {
    let url_ = this.baseUrl + "/invites/code";

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetInviteCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetInviteCode(<any>response_);
        } catch (e) {
          return <Observable<GetUserInviteCodeResult>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetUserInviteCodeResult>><any>_observableThrow(response_);
    }));
  }

  protected processGetInviteCode(response: HttpResponseBase): Observable<GetUserInviteCodeResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetUserInviteCodeResult.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<GetUserInviteCodeResult>(<any>null);
  }

  /**
   * Register invite code.
   * @param inviteCode (required) invite Code.
   * @param userId (required) uuid registered user.
   * @return Success
   */
  registerInviteCode(inviteCode: string, userId: string): Observable<void> {
    let url_ = this.baseUrl + "/invites/register";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify({inviteCode: inviteCode, userId: userId});

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processRegisterInviteCode(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRegisterInviteCode(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processRegisterInviteCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponse.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred. " + _responseText, status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  //SWAP DATA FOR CDR
  CDRSwapSendData(body: CDRSwapStatRequest | undefined, cdrApiUrl: string, cdrApiKey: string): Observable<string> {
    let url_ = cdrApiUrl + "/api/Transit";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json",
        "ApiKey": cdrApiKey,
        "Id": 'Ubikiri'
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCDRSwapSendData(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCDRSwapSendData(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processCDRSwapSendData(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }
}



export class WalletBalanceQueryResult implements IWalletBalanceQueryResult {
  readonly balance?: number | undefined;

  constructor(data?: IWalletBalanceQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).balance = _data["balance"];
    }
  }

  static fromJS(data: any): WalletBalanceQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new WalletBalanceQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["balance"] = this.balance;
    return data;
  }
}

export interface IWalletBalanceQueryResult {
  balance?: number | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
}

/** Transaction model */
export class TransactionViewModel implements ITransactionViewModel {
  /** Hash */
  transaction?: string | undefined;
  /** Coin type */
  coinType?: TransactionViewModelCoinType | undefined;

  constructor(data?: ITransactionViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transaction = _data["transaction"];
      this.coinType = _data["coinType"];
    }
  }

  static fromJS(data: any): TransactionViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new TransactionViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["transaction"] = this.transaction;
    data["coinType"] = this.coinType;
    return data;
  }
}

/** Transaction model */
export interface ITransactionViewModel {
  /** Hash */
  transaction?: string | undefined;
  /** Coin type */
  coinType?: TransactionViewModelCoinType | undefined;
}

/** Unhandled excpetions wrapper */
export class MiddlewareExceptionWrapper implements IMiddlewareExceptionWrapper {
  /** Messgae */
  readonly message?: string | undefined;

  constructor(data?: IMiddlewareExceptionWrapper) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).message = _data["message"];
    }
  }

  static fromJS(data: any): MiddlewareExceptionWrapper {
    data = typeof data === 'object' ? data : {};
    let result = new MiddlewareExceptionWrapper();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["message"] = this.message;
    return data;
  }
}

/** Unhandled excpetions wrapper */
export interface IMiddlewareExceptionWrapper {
  /** Messgae */
  message?: string | undefined;
}

export class WalletTokenBalanceQueryResult implements IWalletTokenBalanceQueryResult {
  readonly tokenBalance?: number | undefined;

  constructor(data?: IWalletTokenBalanceQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).tokenBalance = _data["tokenBalance"];
    }
  }

  static fromJS(data: any): WalletTokenBalanceQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new WalletTokenBalanceQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tokenBalance"] = this.tokenBalance;
    return data;
  }
}

export interface IWalletTokenBalanceQueryResult {
  tokenBalance?: number | undefined;
}

export class TokenInfoQueryResult implements ITokenInfoQueryResult {
  readonly name?: string | undefined;
  readonly symbol?: string | undefined;
  readonly decimals?: number | undefined;

  constructor(data?: ITokenInfoQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).name = _data["name"];
      (<any>this).symbol = _data["symbol"];
      (<any>this).decimals = _data["decimals"];
    }
  }

  static fromJS(data: any): TokenInfoQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new TokenInfoQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["symbol"] = this.symbol;
    data["decimals"] = this.decimals;
    return data;
  }
}

export interface ITokenInfoQueryResult {
  name?: string | undefined;
  symbol?: string | undefined;
  decimals?: number | undefined;
}

export class TransactionFeeQueryResult implements ITransactionFeeQueryResult {
  transactionFee?: TransactionFee[] | undefined;
  limit?: number | undefined;

  constructor(data?: ITransactionFeeQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["transactionFee"])) {
        this.transactionFee = [] as any;
        for (let item of _data["transactionFee"])
          this.transactionFee!.push(TransactionFee.fromJS(item));
      }
      this.limit = _data["limit"];
    }
  }

  static fromJS(data: any): TransactionFeeQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new TransactionFeeQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.transactionFee)) {
      data["transactionFee"] = [];
      for (let item of this.transactionFee)
        data["transactionFee"].push(item.toJSON());
    }
    data["limit"] = this.limit;
    return data;
  }
}

export interface ITransactionFeeQueryResult {
  transactionFee?: TransactionFee[] | undefined;
  limit?: number | undefined;
}

export class TransactionFee implements ITransactionFee {
  type?: TransactionFeeType | undefined;
  value?: string | undefined;
  coinValue?: number | undefined;

  constructor(data?: ITransactionFee) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.value = _data["value"];
      this.coinValue = _data["coinValue"];
    }
  }

  static fromJS(data: any): TransactionFee {
    data = typeof data === 'object' ? data : {};
    let result = new TransactionFee();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    data["value"] = this.value;
    data["coinValue"] = this.coinValue;
    return data;
  }
}

export interface ITransactionFee {
  type?: TransactionFeeType | undefined;
  value?: string | undefined;
  coinValue?: number | undefined;
}

export class SingleQueryResultOfString implements ISingleQueryResultOfString {
  data?: string | undefined;

  constructor(data?: ISingleQueryResultOfString) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.data = _data["data"];
    }
  }

  static fromJS(data: any): SingleQueryResultOfString {
    data = typeof data === 'object' ? data : {};
    let result = new SingleQueryResultOfString();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["data"] = this.data;
    return data;
  }
}

export interface ISingleQueryResultOfString {
  data?: string | undefined;
}

export class TransactionCountQueryResult implements ITransactionCountQueryResult {
  readonly nonce?: string | undefined;

  constructor(data?: ITransactionCountQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).nonce = _data["nonce"];
    }
  }

  static fromJS(data: any): TransactionCountQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new TransactionCountQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["nonce"] = this.nonce;
    return data;
  }
}

export interface ITransactionCountQueryResult {
  nonce?: string | undefined;
}

export class WalletListUnspentQueryResult implements IWalletListUnspentQueryResult {
  readonly items?: CilWalletListUnspentItem[] | undefined;

  constructor(data?: IWalletListUnspentQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        (<any>this).items = [] as any;
        for (let item of _data["items"])
          (<any>this).items!.push(CilWalletListUnspentItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): WalletListUnspentQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new WalletListUnspentQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IWalletListUnspentQueryResult {
  items?: CilWalletListUnspentItem[] | undefined;
}

export class CilWalletListUnspentItem implements ICilWalletListUnspentItem {
  amount?: number | undefined;
  hash?: string | undefined;
  nOut?: number | undefined;
  isStable?: boolean | undefined;

  constructor(data?: ICilWalletListUnspentItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.amount = _data["amount"];
      this.hash = _data["hash"];
      this.nOut = _data["nOut"];
      this.isStable = _data["isStable"];
    }
  }

  static fromJS(data: any): CilWalletListUnspentItem {
    data = typeof data === 'object' ? data : {};
    let result = new CilWalletListUnspentItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["amount"] = this.amount;
    data["hash"] = this.hash;
    data["nOut"] = this.nOut;
    data["isStable"] = this.isStable;
    return data;
  }
}

export interface ICilWalletListUnspentItem {
  amount?: number | undefined;
  hash?: string | undefined;
  nOut?: number | undefined;
  isStable?: boolean | undefined;
}

export class TransactionReceiptQueryResult implements ITransactionReceiptQueryResult {

  constructor(data?: ITransactionReceiptQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): TransactionReceiptQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new TransactionReceiptQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    return data;
  }
}

export interface ITransactionReceiptQueryResult {
}

export class ForumOptions implements IForumOptions {
  contractAddress?: string | undefined;
  consiliumIdInCil?: number | undefined;
  payAmount?: number | undefined;

  constructor(data?: IForumOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contractAddress = _data["contractAddress"];
      this.consiliumIdInCil = _data["consiliumIdInCil"];
      this.payAmount = _data["payAmount"];
    }
  }

  static fromJS(data: any): ForumOptions {
    data = typeof data === 'object' ? data : {};
    let result = new ForumOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["contractAddress"] = this.contractAddress;
    data["consiliumIdInCil"] = this.consiliumIdInCil;
    data["payAmount"] = this.payAmount;
    return data;
  }
}

export interface IForumOptions {
  contractAddress?: string | undefined;
  consiliumIdInCil?: number | undefined;
  payAmount?: number | undefined;
}

export class CommentDto implements ICommentDto {
  profileId?: number | undefined;
  message?: string | undefined;
  fileName?: string | undefined;
  id?: number | undefined;
  postId?: number | undefined;

  constructor(data?: ICommentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.message = _data["message"];
      this.fileName = _data["fileName"];
      this.id = _data["id"];
      this.postId = _data["postId"];
    }
  }

  static fromJS(data: any): CommentDto {
    data = typeof data === 'object' ? data : {};
    let result = new CommentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["message"] = this.message;
    data["fileName"] = this.fileName;
    data["id"] = this.id;
    data["postId"] = this.postId;
    return data;
  }
}

export interface ICommentDto {
  profileId?: number | undefined;
  message?: string | undefined;
  fileName?: string | undefined;
  id?: number | undefined;
  postId?: number | undefined;
}

export class MultipleQueryResultOfCommentDetailDto implements IMultipleQueryResultOfCommentDetailDto {
  count?: number | undefined;
  data?: CommentDetailDto[] | undefined;

  constructor(data?: IMultipleQueryResultOfCommentDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(CommentDetailDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MultipleQueryResultOfCommentDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new MultipleQueryResultOfCommentDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMultipleQueryResultOfCommentDetailDto {
  count?: number | undefined;
  data?: CommentDetailDto[] | undefined;
}

export class CommentDetailDto implements ICommentDetailDto {
  createdDateTime?: Date | undefined;
  signedDateTime?: Date | undefined;
  likesCount?: number | undefined;
  isLiked?: boolean | undefined;
  profileId?: number | undefined;
  message?: string | undefined;
  fileName?: string | undefined;
  id?: number | undefined;
  postId?: number | undefined;

  constructor(data?: ICommentDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
      this.signedDateTime = _data["signedDateTime"] ? new Date(_data["signedDateTime"].toString()) : <any>undefined;
      this.likesCount = _data["likesCount"];
      this.isLiked = _data["isLiked"];
      this.profileId = _data["profileId"];
      this.message = _data["message"];
      this.fileName = _data["fileName"];
      this.id = _data["id"];
      this.postId = _data["postId"];
    }
  }

  static fromJS(data: any): CommentDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new CommentDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
    data["signedDateTime"] = this.signedDateTime ? this.signedDateTime.toISOString() : <any>undefined;
    data["likesCount"] = this.likesCount;
    data["isLiked"] = this.isLiked;
    data["profileId"] = this.profileId;
    data["message"] = this.message;
    data["fileName"] = this.fileName;
    data["id"] = this.id;
    data["postId"] = this.postId;
    return data;
  }
}

export interface ICommentDetailDto {
  createdDateTime?: Date | undefined;
  signedDateTime?: Date | undefined;
  likesCount?: number | undefined;
  isLiked?: boolean | undefined;
  profileId?: number | undefined;
  message?: string | undefined;
  fileName?: string | undefined;
  id?: number | undefined;
  postId?: number | undefined;
}

export class BaseCommentDto implements IBaseCommentDto {
  id?: number | undefined;
  postId?: number | undefined;

  constructor(data?: IBaseCommentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.postId = _data["postId"];
    }
  }

  static fromJS(data: any): BaseCommentDto {
    data = typeof data === 'object' ? data : {};
    let result = new BaseCommentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["postId"] = this.postId;
    return data;
  }
}

export interface IBaseCommentDto {
  id?: number | undefined;
  postId?: number | undefined;
}

export class ConsiliumsResult implements IConsiliumsResult {
  consiliums?: ConsiliumModel[] | undefined;
  consiliumCountStatistic?: CountStatistic | undefined;

  constructor(data?: IConsiliumsResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["consiliums"])) {
        this.consiliums = [] as any;
        for (let item of _data["consiliums"])
          this.consiliums!.push(ConsiliumModel.fromJS(item));
      }
      this.consiliumCountStatistic = _data["consiliumCountStatistic"] ? CountStatistic.fromJS(_data["consiliumCountStatistic"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ConsiliumsResult {
    data = typeof data === 'object' ? data : {};
    let result = new ConsiliumsResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.consiliums)) {
      data["consiliums"] = [];
      for (let item of this.consiliums)
        data["consiliums"].push(item.toJSON());
    }
    data["consiliumCountStatistic"] = this.consiliumCountStatistic ? this.consiliumCountStatistic.toJSON() : <any>undefined;
    return data;
  }
}

export interface IConsiliumsResult {
  consiliums?: ConsiliumModel[] | undefined;
  consiliumCountStatistic?: CountStatistic | undefined;
}

export class ConsiliumModel implements IConsiliumModel {
  id?: number | undefined;
  profileId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  smartContractAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isConfirmed?: boolean | undefined;

  constructor(data?: IConsiliumModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.consiliumIdInCil = _data["consiliumIdInCil"];
      this.smartContractAddress = _data["smartContractAddress"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.isFavorite = _data["isFavorite"];
      this.isConfirmed = _data["isConfirmed"];
    }
  }

  static fromJS(data: any): ConsiliumModel {
    data = typeof data === 'object' ? data : {};
    let result = new ConsiliumModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["consiliumIdInCil"] = this.consiliumIdInCil;
    data["smartContractAddress"] = this.smartContractAddress;
    data["name"] = this.name;
    data["description"] = this.description;
    data["isFavorite"] = this.isFavorite;
    data["isConfirmed"] = this.isConfirmed;
    return data;
  }
}

export interface IConsiliumModel {
  id?: number | undefined;
  profileId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  smartContractAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isConfirmed?: boolean | undefined;
}

export class CountStatistic implements ICountStatistic {
  total?: number | undefined;
  favorite?: number | undefined;
  currentProfile?: number | undefined;

  constructor(data?: ICountStatistic) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.total = _data["total"];
      this.favorite = _data["favorite"];
      this.currentProfile = _data["currentProfile"];
    }
  }

  static fromJS(data: any): CountStatistic {
    data = typeof data === 'object' ? data : {};
    let result = new CountStatistic();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["total"] = this.total;
    data["favorite"] = this.favorite;
    data["currentProfile"] = this.currentProfile;
    return data;
  }
}

export interface ICountStatistic {
  total?: number | undefined;
  favorite?: number | undefined;
  currentProfile?: number | undefined;
}

export class ConsiliumDetailResult implements IConsiliumDetailResult {
  creator?: string | undefined;
  fileName?: string | undefined;
  fileHash?: string | undefined;
  txEthereum?: string | undefined;
  txCil?: string | undefined;
  createdIn?: string | undefined;
  value?: number | undefined;
  id?: number | undefined;
  profileId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  smartContractAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isConfirmed?: boolean | undefined;

  constructor(data?: IConsiliumDetailResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creator = _data["creator"];
      this.fileName = _data["fileName"];
      this.fileHash = _data["fileHash"];
      this.txEthereum = _data["txEthereum"];
      this.txCil = _data["txCil"];
      this.createdIn = _data["createdIn"];
      this.value = _data["value"];
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.consiliumIdInCil = _data["consiliumIdInCil"];
      this.smartContractAddress = _data["smartContractAddress"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.isFavorite = _data["isFavorite"];
      this.isConfirmed = _data["isConfirmed"];
    }
  }

  static fromJS(data: any): ConsiliumDetailResult {
    data = typeof data === 'object' ? data : {};
    let result = new ConsiliumDetailResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["creator"] = this.creator;
    data["fileName"] = this.fileName;
    data["fileHash"] = this.fileHash;
    data["txEthereum"] = this.txEthereum;
    data["txCil"] = this.txCil;
    data["createdIn"] = this.createdIn;
    data["value"] = this.value;
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["consiliumIdInCil"] = this.consiliumIdInCil;
    data["smartContractAddress"] = this.smartContractAddress;
    data["name"] = this.name;
    data["description"] = this.description;
    data["isFavorite"] = this.isFavorite;
    data["isConfirmed"] = this.isConfirmed;
    return data;
  }
}

export interface IConsiliumDetailResult {
  creator?: string | undefined;
  fileName?: string | undefined;
  fileHash?: string | undefined;
  txEthereum?: string | undefined;
  txCil?: string | undefined;
  createdIn?: string | undefined;
  value?: number | undefined;
  id?: number | undefined;
  profileId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  smartContractAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isConfirmed?: boolean | undefined;
}

/** Add entity to favorite model */
export class AddToFavoriteViewModel implements IAddToFavoriteViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Entity id */
  id?: number | undefined;
  /** Favorite Smart Contract Type */
  favoriteType?: AddToFavoriteViewModelFavoriteType | undefined;

  constructor(data?: IAddToFavoriteViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.id = _data["id"];
      this.favoriteType = _data["favoriteType"];
    }
  }

  static fromJS(data: any): AddToFavoriteViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new AddToFavoriteViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["id"] = this.id;
    data["favoriteType"] = this.favoriteType;
    return data;
  }
}

/** Add entity to favorite model */
export interface IAddToFavoriteViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Entity id */
  id?: number | undefined;
  /** Favorite Smart Contract Type */
  favoriteType?: AddToFavoriteViewModelFavoriteType | undefined;
}

export class ConsiliumTotalAmountResult implements IConsiliumTotalAmountResult {
  totalAmount?: number | undefined;

  constructor(data?: IConsiliumTotalAmountResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalAmount = _data["totalAmount"];
    }
  }

  static fromJS(data: any): ConsiliumTotalAmountResult {
    data = typeof data === 'object' ? data : {};
    let result = new ConsiliumTotalAmountResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalAmount"] = this.totalAmount;
    return data;
  }
}

export interface IConsiliumTotalAmountResult {
  totalAmount?: number | undefined;
}

export class LastBlockResult implements ILastBlockResult {
  lastBlock?: string | undefined;

  constructor(data?: ILastBlockResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lastBlock = _data["lastBlock"];
    }
  }

  static fromJS(data: any): LastBlockResult {
    data = typeof data === 'object' ? data : {};
    let result = new LastBlockResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastBlock"] = this.lastBlock;
    return data;
  }
}

export interface ILastBlockResult {
  lastBlock?: string | undefined;
}

export class ParticipantsProfileIdsResult implements IParticipantsProfileIdsResult {
  profileIds?: number[] | undefined;

  constructor(data?: IParticipantsProfileIdsResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["profileIds"])) {
        this.profileIds = [] as any;
        for (let item of _data["profileIds"])
          this.profileIds!.push(item);
      }
    }
  }

  static fromJS(data: any): ParticipantsProfileIdsResult {
    data = typeof data === 'object' ? data : {};
    let result = new ParticipantsProfileIdsResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.profileIds)) {
      data["profileIds"] = [];
      for (let item of this.profileIds)
        data["profileIds"].push(item);
    }
    return data;
  }
}

export interface IParticipantsProfileIdsResult {
  profileIds?: number[] | undefined;
}

export class MultipleQueryResultOfPostDetailDto implements IMultipleQueryResultOfPostDetailDto {
  count?: number | undefined;
  data?: PostDetailDto[] | undefined;

  constructor(data?: IMultipleQueryResultOfPostDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(PostDetailDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MultipleQueryResultOfPostDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new MultipleQueryResultOfPostDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMultipleQueryResultOfPostDetailDto {
  count?: number | undefined;
  data?: PostDetailDto[] | undefined;
}

export class PostDetailDto implements IPostDetailDto {
  createdDateTime?: Date | undefined;
  signedDateTime?: Date | undefined;
  signedWalletAddress?: string | undefined;
  commentsCount?: number | undefined;
  likesCount?: number | undefined;
  isLiked?: boolean | undefined;
  hash?: string | undefined;
  id?: number | undefined;
  displayId?: string | undefined;
  profileId?: number | undefined;
  title?: string | undefined;
  message?: string | undefined;
  fileName?: string | undefined;

  constructor(data?: IPostDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
      this.signedDateTime = _data["signedDateTime"] ? new Date(_data["signedDateTime"].toString()) : <any>undefined;
      this.signedWalletAddress = _data["signedWalletAddress"];
      this.commentsCount = _data["commentsCount"];
      this.likesCount = _data["likesCount"];
      this.isLiked = _data["isLiked"];
      this.hash = _data["hash"];
      this.id = _data["id"];
      this.displayId = _data["displayId"];
      this.profileId = _data["profileId"];
      this.title = _data["title"];
      this.message = _data["message"];
      this.fileName = _data["fileName"];
    }
  }

  static fromJS(data: any): PostDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new PostDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
    data["signedDateTime"] = this.signedDateTime ? this.signedDateTime.toISOString() : <any>undefined;
    data["signedWalletAddress"] = this.signedWalletAddress;
    data["commentsCount"] = this.commentsCount;
    data["likesCount"] = this.likesCount;
    data["isLiked"] = this.isLiked;
    data["hash"] = this.hash;
    data["id"] = this.id;
    data["displayId"] = this.displayId;
    data["profileId"] = this.profileId;
    data["title"] = this.title;
    data["message"] = this.message;
    data["fileName"] = this.fileName;
    return data;
  }
}

export interface IPostDetailDto {
  createdDateTime?: Date | undefined;
  signedDateTime?: Date | undefined;
  signedWalletAddress?: string | undefined;
  commentsCount?: number | undefined;
  likesCount?: number | undefined;
  isLiked?: boolean | undefined;
  hash?: string | undefined;
  id?: number | undefined;
  displayId?: string | undefined;
  profileId?: number | undefined;
  title?: string | undefined;
  message?: string | undefined;
  fileName?: string | undefined;
}

/** Upload file model */
export class UploadFileRequest implements IUploadFileRequest {
  /** base64 string image */
  base64Data?: string | undefined;

  constructor(data?: IUploadFileRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.base64Data = _data["base64Data"];
    }
  }

  static fromJS(data: any): UploadFileRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UploadFileRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["base64Data"] = this.base64Data;
    return data;
  }
}

/** Upload file model */
export interface IUploadFileRequest {
  /** base64 string image */
  base64Data?: string | undefined;
}

export class GamesResult implements IGamesResult {
  games?: GameModel[] | undefined;
  gamesCountStatistic?: GamesCountStatistic | undefined;

  constructor(data?: IGamesResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["games"])) {
        this.games = [] as any;
        for (let item of _data["games"])
          this.games!.push(GameModel.fromJS(item));
      }
      this.gamesCountStatistic = _data["gamesCountStatistic"] ? GamesCountStatistic.fromJS(_data["gamesCountStatistic"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GamesResult {
    data = typeof data === 'object' ? data : {};
    let result = new GamesResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.games)) {
      data["games"] = [];
      for (let item of this.games)
        data["games"].push(item.toJSON());
    }
    data["gamesCountStatistic"] = this.gamesCountStatistic ? this.gamesCountStatistic.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGamesResult {
  games?: GameModel[] | undefined;
  gamesCountStatistic?: GamesCountStatistic | undefined;
}

export class GameModel implements IGameModel {
  id?: number | undefined;
  profileId?: number | undefined;
  isJoined?: boolean | undefined;
  name?: string | undefined;
  buyIn?: number | undefined;
  gameStart?: Date | undefined;
  gameEnd?: Date | undefined;
  ticker?: string | undefined;
  description?: string | undefined;
  playersCount?: number | undefined;
  maxPlayers?: number | undefined;
  prizePool?: number | undefined;
  gameStatus?: GameModelGameStatus | undefined;
  chipsStart?: number | undefined;
  addressWinner?: string | undefined;
  canJoin?: boolean | undefined;
  profileIdsWinner?: number[] | undefined;

  constructor(data?: IGameModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.isJoined = _data["isJoined"];
      this.name = _data["name"];
      this.buyIn = _data["buyIn"];
      this.gameStart = _data["gameStart"] ? new Date(_data["gameStart"].toString()) : <any>undefined;
      this.gameEnd = _data["gameEnd"] ? new Date(_data["gameEnd"].toString()) : <any>undefined;
      this.ticker = _data["ticker"];
      this.description = _data["description"];
      this.playersCount = _data["playersCount"];
      this.maxPlayers = _data["maxPlayers"];
      this.prizePool = _data["prizePool"];
      this.gameStatus = _data["gameStatus"];
      this.chipsStart = _data["chipsStart"];
      this.addressWinner = _data["addressWinner"];
      this.canJoin = _data["canJoin"];
      if (Array.isArray(_data["profileIdsWinner"])) {
        this.profileIdsWinner = [] as any;
        for (let item of _data["profileIdsWinner"])
          this.profileIdsWinner!.push(item);
      }
    }
  }

  static fromJS(data: any): GameModel {
    data = typeof data === 'object' ? data : {};
    let result = new GameModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["isJoined"] = this.isJoined;
    data["name"] = this.name;
    data["buyIn"] = this.buyIn;
    data["gameStart"] = this.gameStart ? this.gameStart.toISOString() : <any>undefined;
    data["gameEnd"] = this.gameEnd ? this.gameEnd.toISOString() : <any>undefined;
    data["ticker"] = this.ticker;
    data["description"] = this.description;
    data["playersCount"] = this.playersCount;
    data["maxPlayers"] = this.maxPlayers;
    data["prizePool"] = this.prizePool;
    data["gameStatus"] = this.gameStatus;
    data["chipsStart"] = this.chipsStart;
    data["addressWinner"] = this.addressWinner;
    data["canJoin"] = this.canJoin;
    if (Array.isArray(this.profileIdsWinner)) {
      data["profileIdsWinner"] = [];
      for (let item of this.profileIdsWinner)
        data["profileIdsWinner"].push(item);
    }
    return data;
  }
}

export interface IGameModel {
  id?: number | undefined;
  profileId?: number | undefined;
  isJoined?: boolean | undefined;
  name?: string | undefined;
  buyIn?: number | undefined;
  gameStart?: Date | undefined;
  gameEnd?: Date | undefined;
  ticker?: string | undefined;
  description?: string | undefined;
  playersCount?: number | undefined;
  maxPlayers?: number | undefined;
  prizePool?: number | undefined;
  gameStatus?: GameModelGameStatus | undefined;
  chipsStart?: number | undefined;
  addressWinner?: string | undefined;
  canJoin?: boolean | undefined;
  profileIdsWinner?: number[] | undefined;
}

export class GamesCountStatistic implements IGamesCountStatistic {
  scheduled?: number | undefined;
  cancelled?: number | undefined;
  finished?: number | undefined;
  inProgress?: number | undefined;

  constructor(data?: IGamesCountStatistic) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scheduled = _data["scheduled"];
      this.cancelled = _data["cancelled"];
      this.finished = _data["finished"];
      this.inProgress = _data["inProgress"];
    }
  }

  static fromJS(data: any): GamesCountStatistic {
    data = typeof data === 'object' ? data : {};
    let result = new GamesCountStatistic();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["scheduled"] = this.scheduled;
    data["cancelled"] = this.cancelled;
    data["finished"] = this.finished;
    data["inProgress"] = this.inProgress;
    return data;
  }
}

export interface IGamesCountStatistic {
  scheduled?: number | undefined;
  cancelled?: number | undefined;
  finished?: number | undefined;
  inProgress?: number | undefined;
}

export class GameDetailResult implements IGameDetailResult {
  creator?: string | undefined;
  consiliumName?: string | undefined;
  consiliumId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  smartContractName?: string | undefined;
  smartContractAddress?: string | undefined;
  smartContractId?: number | undefined;
  id?: number | undefined;
  profileId?: number | undefined;
  isJoined?: boolean | undefined;
  name?: string | undefined;
  buyIn?: number | undefined;
  gameStart?: Date | undefined;
  gameEnd?: Date | undefined;
  ticker?: string | undefined;
  description?: string | undefined;
  playersCount?: number | undefined;
  maxPlayers?: number | undefined;
  prizePool?: number | undefined;
  gameStatus?: GameDetailResultGameStatus | undefined;
  chipsStart?: number | undefined;
  addressWinner?: string | undefined;
  canJoin?: boolean | undefined;
  profileIdsWinner?: number[] | undefined;

  constructor(data?: IGameDetailResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creator = _data["creator"];
      this.consiliumName = _data["consiliumName"];
      this.consiliumId = _data["consiliumId"];
      this.consiliumIdInCil = _data["consiliumIdInCil"];
      this.smartContractName = _data["smartContractName"];
      this.smartContractAddress = _data["smartContractAddress"];
      this.smartContractId = _data["smartContractId"];
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.isJoined = _data["isJoined"];
      this.name = _data["name"];
      this.buyIn = _data["buyIn"];
      this.gameStart = _data["gameStart"] ? new Date(_data["gameStart"].toString()) : <any>undefined;
      this.gameEnd = _data["gameEnd"] ? new Date(_data["gameEnd"].toString()) : <any>undefined;
      this.ticker = _data["ticker"];
      this.description = _data["description"];
      this.playersCount = _data["playersCount"];
      this.maxPlayers = _data["maxPlayers"];
      this.prizePool = _data["prizePool"];
      this.gameStatus = _data["gameStatus"];
      this.chipsStart = _data["chipsStart"];
      this.addressWinner = _data["addressWinner"];
      this.canJoin = _data["canJoin"];
      if (Array.isArray(_data["profileIdsWinner"])) {
        this.profileIdsWinner = [] as any;
        for (let item of _data["profileIdsWinner"])
          this.profileIdsWinner!.push(item);
      }
    }
  }

  static fromJS(data: any): GameDetailResult {
    data = typeof data === 'object' ? data : {};
    let result = new GameDetailResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["creator"] = this.creator;
    data["consiliumName"] = this.consiliumName;
    data["consiliumId"] = this.consiliumId;
    data["consiliumIdInCil"] = this.consiliumIdInCil;
    data["smartContractName"] = this.smartContractName;
    data["smartContractAddress"] = this.smartContractAddress;
    data["smartContractId"] = this.smartContractId;
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["isJoined"] = this.isJoined;
    data["name"] = this.name;
    data["buyIn"] = this.buyIn;
    data["gameStart"] = this.gameStart ? this.gameStart.toISOString() : <any>undefined;
    data["gameEnd"] = this.gameEnd ? this.gameEnd.toISOString() : <any>undefined;
    data["ticker"] = this.ticker;
    data["description"] = this.description;
    data["playersCount"] = this.playersCount;
    data["maxPlayers"] = this.maxPlayers;
    data["prizePool"] = this.prizePool;
    data["gameStatus"] = this.gameStatus;
    data["chipsStart"] = this.chipsStart;
    data["addressWinner"] = this.addressWinner;
    data["canJoin"] = this.canJoin;
    if (Array.isArray(this.profileIdsWinner)) {
      data["profileIdsWinner"] = [];
      for (let item of this.profileIdsWinner)
        data["profileIdsWinner"].push(item);
    }
    return data;
  }
}

export interface IGameDetailResult {
  creator?: string | undefined;
  consiliumName?: string | undefined;
  consiliumId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  smartContractName?: string | undefined;
  smartContractAddress?: string | undefined;
  smartContractId?: number | undefined;
  id?: number | undefined;
  profileId?: number | undefined;
  isJoined?: boolean | undefined;
  name?: string | undefined;
  buyIn?: number | undefined;
  gameStart?: Date | undefined;
  gameEnd?: Date | undefined;
  ticker?: string | undefined;
  description?: string | undefined;
  playersCount?: number | undefined;
  maxPlayers?: number | undefined;
  prizePool?: number | undefined;
  gameStatus?: GameDetailResultGameStatus | undefined;
  chipsStart?: number | undefined;
  addressWinner?: string | undefined;
  canJoin?: boolean | undefined;
  profileIdsWinner?: number[] | undefined;
}

export class GamePlayersResult implements IGamePlayersResult {
  profileIds?: number[] | undefined;

  constructor(data?: IGamePlayersResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["profileIds"])) {
        this.profileIds = [] as any;
        for (let item of _data["profileIds"])
          this.profileIds!.push(item);
      }
    }
  }

  static fromJS(data: any): GamePlayersResult {
    data = typeof data === 'object' ? data : {};
    let result = new GamePlayersResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.profileIds)) {
      data["profileIds"] = [];
      for (let item of this.profileIds)
        data["profileIds"].push(item);
    }
    return data;
  }
}

export interface IGamePlayersResult {
  profileIds?: number[] | undefined;
}

export class ChartDataQueryResult implements IChartDataQueryResult {
  data?: ChartData[] | undefined;

  constructor(data?: IChartDataQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(ChartData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ChartDataQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new ChartDataQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IChartDataQueryResult {
  data?: ChartData[] | undefined;
}

export class ChartData implements IChartData {
  name?: string | undefined;
  series?: SeriesData[] | undefined;

  constructor(data?: IChartData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      if (Array.isArray(_data["series"])) {
        this.series = [] as any;
        for (let item of _data["series"])
          this.series!.push(SeriesData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ChartData {
    data = typeof data === 'object' ? data : {};
    let result = new ChartData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    if (Array.isArray(this.series)) {
      data["series"] = [];
      for (let item of this.series)
        data["series"].push(item.toJSON());
    }
    return data;
  }
}

export interface IChartData {
  name?: string | undefined;
  series?: SeriesData[] | undefined;
}

export class SeriesData implements ISeriesData {
  name?: Date | undefined;
  value?: number | undefined;

  constructor(data?: ISeriesData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] ? new Date(_data["name"].toString()) : <any>undefined;
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): SeriesData {
    data = typeof data === 'object' ? data : {};
    let result = new SeriesData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name ? this.name.toISOString() : <any>undefined;
    data["value"] = this.value;
    return data;
  }
}

export interface ISeriesData {
  name?: Date | undefined;
  value?: number | undefined;
}

export class GamePlayersModel implements IGamePlayersModel {
  profileId?: number | undefined;
  chipsAmount?: number | undefined;
  tickerAmount?: number | undefined;
  totalTickerAmount?: number | undefined;
  currentRate?: number | undefined;

  constructor(data?: IGamePlayersModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.chipsAmount = _data["chipsAmount"];
      this.tickerAmount = _data["tickerAmount"];
      this.totalTickerAmount = _data["totalTickerAmount"];
      this.currentRate = _data["currentRate"];
    }
  }

  static fromJS(data: any): GamePlayersModel {
    data = typeof data === 'object' ? data : {};
    let result = new GamePlayersModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["chipsAmount"] = this.chipsAmount;
    data["tickerAmount"] = this.tickerAmount;
    data["totalTickerAmount"] = this.totalTickerAmount;
    data["currentRate"] = this.currentRate;
    return data;
  }
}

export interface IGamePlayersModel {
  profileId?: number | undefined;
  chipsAmount?: number | undefined;
  tickerAmount?: number | undefined;
  totalTickerAmount?: number | undefined;
  currentRate?: number | undefined;
}

export class RatingResult implements IRatingResult {
  items?: RatingModel[] | undefined;

  constructor(data?: IRatingResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(RatingModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RatingResult {
    data = typeof data === 'object' ? data : {};
    let result = new RatingResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IRatingResult {
  items?: RatingModel[] | undefined;
}

export class RatingModel implements IRatingModel {
  profileId?: number | undefined;
  walletAddress?: string | undefined;
  amount?: number | undefined;

  constructor(data?: IRatingModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.walletAddress = _data["walletAddress"];
      this.amount = _data["amount"];
    }
  }

  static fromJS(data: any): RatingModel {
    data = typeof data === 'object' ? data : {};
    let result = new RatingModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["walletAddress"] = this.walletAddress;
    data["amount"] = this.amount;
    return data;
  }
}

export interface IRatingModel {
  profileId?: number | undefined;
  walletAddress?: string | undefined;
  amount?: number | undefined;
}

export class TradeHistoryResult implements ITradeHistoryResult {
  items?: TradeHistoryModel[] | undefined;

  constructor(data?: ITradeHistoryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(TradeHistoryModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TradeHistoryResult {
    data = typeof data === 'object' ? data : {};
    let result = new TradeHistoryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface ITradeHistoryResult {
  items?: TradeHistoryModel[] | undefined;
}

export class TradeHistoryModel implements ITradeHistoryModel {
  profileId?: number | undefined;
  walletAddress?: string | undefined;
  tradeDateTime?: Date | undefined;
  rate?: number | undefined;
  amount?: number | undefined;

  constructor(data?: ITradeHistoryModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.walletAddress = _data["walletAddress"];
      this.tradeDateTime = _data["tradeDateTime"] ? new Date(_data["tradeDateTime"].toString()) : <any>undefined;
      this.rate = _data["rate"];
      this.amount = _data["amount"];
    }
  }

  static fromJS(data: any): TradeHistoryModel {
    data = typeof data === 'object' ? data : {};
    let result = new TradeHistoryModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["walletAddress"] = this.walletAddress;
    data["tradeDateTime"] = this.tradeDateTime ? this.tradeDateTime.toISOString() : <any>undefined;
    data["rate"] = this.rate;
    data["amount"] = this.amount;
    return data;
  }
}

export interface ITradeHistoryModel {
  profileId?: number | undefined;
  walletAddress?: string | undefined;
  tradeDateTime?: Date | undefined;
  rate?: number | undefined;
  amount?: number | undefined;
}

export class PostLikeRequest implements IPostLikeRequest {
  postId?: number | undefined;
  profileId?: number | undefined;

  constructor(data?: IPostLikeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.postId = _data["postId"];
      this.profileId = _data["profileId"];
    }
  }

  static fromJS(data: any): PostLikeRequest {
    data = typeof data === 'object' ? data : {};
    let result = new PostLikeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["postId"] = this.postId;
    data["profileId"] = this.profileId;
    return data;
  }
}

export interface IPostLikeRequest {
  postId?: number | undefined;
  profileId?: number | undefined;
}

export class CommentLikeRequest implements ICommentLikeRequest {
  commentId?: number | undefined;
  profileId?: number | undefined;

  constructor(data?: ICommentLikeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.commentId = _data["commentId"];
      this.profileId = _data["profileId"];
    }
  }

  static fromJS(data: any): CommentLikeRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CommentLikeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["commentId"] = this.commentId;
    data["profileId"] = this.profileId;
    return data;
  }
}

export interface ICommentLikeRequest {
  commentId?: number | undefined;
  profileId?: number | undefined;
}

export class PostDto implements IPostDto {
  id?: number | undefined;
  displayId?: string | undefined;
  profileId?: number | undefined;
  title?: string | undefined;
  message?: string | undefined;
  fileName?: string | undefined;

  constructor(data?: IPostDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayId = _data["displayId"];
      this.profileId = _data["profileId"];
      this.title = _data["title"];
      this.message = _data["message"];
      this.fileName = _data["fileName"];
    }
  }

  static fromJS(data: any): PostDto {
    data = typeof data === 'object' ? data : {};
    let result = new PostDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayId"] = this.displayId;
    data["profileId"] = this.profileId;
    data["title"] = this.title;
    data["message"] = this.message;
    data["fileName"] = this.fileName;
    return data;
  }
}

export interface IPostDto {
  id?: number | undefined;
  displayId?: string | undefined;
  profileId?: number | undefined;
  title?: string | undefined;
  message?: string | undefined;
  fileName?: string | undefined;
}

export class SingleQueryResultOfPostDetailDto implements ISingleQueryResultOfPostDetailDto {
  data?: PostDetailDto | undefined;

  constructor(data?: ISingleQueryResultOfPostDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.data = _data["data"] ? PostDetailDto.fromJS(_data["data"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SingleQueryResultOfPostDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new SingleQueryResultOfPostDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISingleQueryResultOfPostDetailDto {
  data?: PostDetailDto | undefined;
}

export class ProfilePostViewModel implements IProfilePostViewModel {
  postId?: number | undefined;
  profileId?: number | undefined;

  constructor(data?: IProfilePostViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.postId = _data["postId"];
      this.profileId = _data["profileId"];
    }
  }

  static fromJS(data: any): ProfilePostViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ProfilePostViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["postId"] = this.postId;
    data["profileId"] = this.profileId;
    return data;
  }
}

export interface IProfilePostViewModel {
  postId?: number | undefined;
  profileId?: number | undefined;
}

export class ProfilePostWithWalletAddressViewModel implements IProfilePostWithWalletAddressViewModel {
  walletAddress?: string | undefined;
  postId?: number | undefined;
  profileId?: number | undefined;

  constructor(data?: IProfilePostWithWalletAddressViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.walletAddress = _data["walletAddress"];
      this.postId = _data["postId"];
      this.profileId = _data["profileId"];
    }
  }

  static fromJS(data: any): ProfilePostWithWalletAddressViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ProfilePostWithWalletAddressViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["walletAddress"] = this.walletAddress;
    data["postId"] = this.postId;
    data["profileId"] = this.profileId;
    return data;
  }
}

export interface IProfilePostWithWalletAddressViewModel {
  walletAddress?: string | undefined;
  postId?: number | undefined;
  profileId?: number | undefined;
}

export class MultipleQueryResultOfSandboxDto implements IMultipleQueryResultOfSandboxDto {
  count?: number | undefined;
  data?: SandboxDto[] | undefined;

  constructor(data?: IMultipleQueryResultOfSandboxDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(SandboxDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MultipleQueryResultOfSandboxDto {
    data = typeof data === 'object' ? data : {};
    let result = new MultipleQueryResultOfSandboxDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMultipleQueryResultOfSandboxDto {
  count?: number | undefined;
  data?: SandboxDto[] | undefined;
}

export class SandboxDto implements ISandboxDto {
  id?: number | undefined;
  profileId?: number | undefined;
  title?: string | undefined;
  link?: string | undefined;
  logo?: string | undefined;
  tokenSymbol?: string | undefined;
  createdDateTime?: Date | undefined;
  attachments?: AttachmentDto[] | undefined;
  disableParticipation: boolean | undefined;
  constructor(data?: ISandboxDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.title = _data["title"];
      this.link = _data["link"];
      this.logo = _data["logo"];
      this.tokenSymbol = _data["tokenSymbol"];
      this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
      this.disableParticipation = _data["disableParticipation"];
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments!.push(AttachmentDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SandboxDto {
    data = typeof data === 'object' ? data : {};
    let result = new SandboxDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["title"] = this.title;
    data["link"] = this.link;
    data["logo"] = this.logo;
    data["tokenSymbol"] = this.tokenSymbol;
    data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
    data["disableParticipation"] = this.disableParticipation;
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    return data;
  }
}

export interface ISandboxDto {
  id?: number | undefined;
  profileId?: number | undefined;
  title?: string | undefined;
  link?: string | undefined;
  logo?: string | undefined;
  tokenSymbol?: string | undefined;
  createdDateTime?: Date | undefined;
  attachments?: AttachmentDto[] | undefined;
  disableParticipation: boolean | undefined;
}

export class AttachmentDto implements IAttachmentDto {
  id?: number | undefined;
  position?: number | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isDekstop?: boolean | undefined;

  constructor(data?: IAttachmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.position = _data["position"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.isDekstop = _data["isDekstop"];
    }
  }

  static fromJS(data: any): AttachmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new AttachmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["position"] = this.position;
    data["name"] = this.name;
    data["description"] = this.description;
    data["isDekstop"] = this.isDekstop;
    return data;
  }
}

export interface IAttachmentDto {
  id?: number | undefined;
  position?: number | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isDekstop?: boolean | undefined;
}

export class SingleQueryResultOfSandboxDto implements ISingleQueryResultOfSandboxDto {
  data?: SandboxDto | undefined;

  constructor(data?: ISingleQueryResultOfSandboxDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.data = _data["data"] ? SandboxDto.fromJS(_data["data"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SingleQueryResultOfSandboxDto {
    data = typeof data === 'object' ? data : {};
    let result = new SingleQueryResultOfSandboxDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISingleQueryResultOfSandboxDto {
  data?: SandboxDto | undefined;
}

export class SmartContractsResult implements ISmartContractsResult {
  smartContracts?: SmartContractModel[] | undefined;
  smartContractCountStatistic?: CountStatistic | undefined;

  constructor(data?: ISmartContractsResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["smartContracts"])) {
        this.smartContracts = [] as any;
        for (let item of _data["smartContracts"])
          this.smartContracts!.push(SmartContractModel.fromJS(item));
      }
      this.smartContractCountStatistic = _data["smartContractCountStatistic"] ? CountStatistic.fromJS(_data["smartContractCountStatistic"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SmartContractsResult {
    data = typeof data === 'object' ? data : {};
    let result = new SmartContractsResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.smartContracts)) {
      data["smartContracts"] = [];
      for (let item of this.smartContracts)
        data["smartContracts"].push(item.toJSON());
    }
    data["smartContractCountStatistic"] = this.smartContractCountStatistic ? this.smartContractCountStatistic.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISmartContractsResult {
  smartContracts?: SmartContractModel[] | undefined;
  smartContractCountStatistic?: CountStatistic | undefined;
}

export class SmartContractModel implements ISmartContractModel {
  id?: number | undefined;
  profileId?: number | undefined;
  hashAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isSigned?: boolean | undefined;
  isConfirmed?: boolean | undefined;

  constructor(data?: ISmartContractModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.hashAddress = _data["hashAddress"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.isFavorite = _data["isFavorite"];
      this.isSigned = _data["isSigned"];
      this.isConfirmed = _data["isConfirmed"];
    }
  }

  static fromJS(data: any): SmartContractModel {
    data = typeof data === 'object' ? data : {};
    let result = new SmartContractModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["hashAddress"] = this.hashAddress;
    data["name"] = this.name;
    data["description"] = this.description;
    data["isFavorite"] = this.isFavorite;
    data["isSigned"] = this.isSigned;
    data["isConfirmed"] = this.isConfirmed;
    return data;
  }
}

export interface ISmartContractModel {
  id?: number | undefined;
  profileId?: number | undefined;
  hashAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isSigned?: boolean | undefined;
  isConfirmed?: boolean | undefined;
}

/** Smart-contract model */
export class SmartContractViewModel implements ISmartContractViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Hash Address in Blockchain */
  hashAddress?: string | undefined;

  constructor(data?: ISmartContractViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.hashAddress = _data["hashAddress"];
    }
  }

  static fromJS(data: any): SmartContractViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new SmartContractViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["hashAddress"] = this.hashAddress;
    return data;
  }
}

/** Smart-contract model */
export interface ISmartContractViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Hash Address in Blockchain */
  hashAddress?: string | undefined;
}

export class SmartContractDto implements ISmartContractDto {
  id?: number | undefined;
  profileId?: number | undefined;
  hashAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isSigned?: boolean | undefined;
  isConfirmed?: boolean | undefined;
  creator?: string | undefined;
  consiliumName?: string | undefined;
  consiliumId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  fileName?: string | undefined;
  fileHash?: string | undefined;
  txEthereum?: string | undefined;
  txCil?: string | undefined;
  genesisBlock?: string | undefined;
  coinsLimit?: number | undefined;
  methods?: MethodDto[] | undefined;

  constructor(data?: ISmartContractDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.hashAddress = _data["hashAddress"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.isFavorite = _data["isFavorite"];
      this.isSigned = _data["isSigned"];
      this.isConfirmed = _data["isConfirmed"];
      this.creator = _data["creator"];
      this.consiliumName = _data["consiliumName"];
      this.consiliumId = _data["consiliumId"];
      this.consiliumIdInCil = _data["consiliumIdInCil"];
      this.fileName = _data["fileName"];
      this.fileHash = _data["fileHash"];
      this.txEthereum = _data["txEthereum"];
      this.txCil = _data["txCil"];
      this.genesisBlock = _data["genesisBlock"];
      this.coinsLimit = _data["coinsLimit"];
      if (Array.isArray(_data["methods"])) {
        this.methods = [] as any;
        for (let item of _data["methods"])
          this.methods!.push(MethodDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SmartContractDto {
    data = typeof data === 'object' ? data : {};
    let result = new SmartContractDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["hashAddress"] = this.hashAddress;
    data["name"] = this.name;
    data["description"] = this.description;
    data["isFavorite"] = this.isFavorite;
    data["isSigned"] = this.isSigned;
    data["isConfirmed"] = this.isConfirmed;
    data["creator"] = this.creator;
    data["consiliumName"] = this.consiliumName;
    data["consiliumId"] = this.consiliumId;
    data["consiliumIdInCil"] = this.consiliumIdInCil;
    data["fileName"] = this.fileName;
    data["fileHash"] = this.fileHash;
    data["txEthereum"] = this.txEthereum;
    data["txCil"] = this.txCil;
    data["genesisBlock"] = this.genesisBlock;
    data["coinsLimit"] = this.coinsLimit;
    if (Array.isArray(this.methods)) {
      data["methods"] = [];
      for (let item of this.methods)
        data["methods"].push(item.toJSON());
    }
    return data;
  }
}

export interface ISmartContractDto {
  id?: number | undefined;
  profileId?: number | undefined;
  hashAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isSigned?: boolean | undefined;
  isConfirmed?: boolean | undefined;
  creator?: string | undefined;
  consiliumName?: string | undefined;
  consiliumId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  fileName?: string | undefined;
  fileHash?: string | undefined;
  txEthereum?: string | undefined;
  txCil?: string | undefined;
  genesisBlock?: string | undefined;
  coinsLimit?: number | undefined;
  methods?: MethodDto[] | undefined;
}

export class MethodDto implements IMethodDto {
  name?: string | undefined;
  description?: string | undefined;
  parameters?: ParameterDto[] | undefined;

  constructor(data?: IMethodDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.description = _data["description"];
      if (Array.isArray(_data["parameters"])) {
        this.parameters = [] as any;
        for (let item of _data["parameters"])
          this.parameters!.push(ParameterDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MethodDto {
    data = typeof data === 'object' ? data : {};
    let result = new MethodDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["description"] = this.description;
    if (Array.isArray(this.parameters)) {
      data["parameters"] = [];
      for (let item of this.parameters)
        data["parameters"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMethodDto {
  name?: string | undefined;
  description?: string | undefined;
  parameters?: ParameterDto[] | undefined;
}

export class ParameterDto implements IParameterDto {
  name?: string | undefined;
  description?: string | undefined;

  constructor(data?: IParameterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ParameterDto {
    data = typeof data === 'object' ? data : {};
    let result = new ParameterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface IParameterDto {
  name?: string | undefined;
  description?: string | undefined;
}

export class SmartContractDetailResult implements ISmartContractDetailResult {
  creator?: string | undefined;
  consiliumName?: string | undefined;
  consiliumId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  fileName?: string | undefined;
  fileHash?: string | undefined;
  txEthereum?: string | undefined;
  txCil?: string | undefined;
  genesisBlock?: string | undefined;
  coinsLimit: number | undefined;
  methods?: MethodModel[] | undefined;
  id?: number | undefined;
  profileId?: number | undefined;
  hashAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isSigned?: boolean | undefined;
  isConfirmed?: boolean | undefined;

  constructor(data?: ISmartContractDetailResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creator = _data["creator"];
      this.consiliumName = _data["consiliumName"];
      this.consiliumId = _data["consiliumId"];
      this.consiliumIdInCil = _data["consiliumIdInCil"];
      this.fileName = _data["fileName"];
      this.fileHash = _data["fileHash"];
      this.txEthereum = _data["txEthereum"];
      this.txCil = _data["txCil"];
      this.genesisBlock = _data["genesisBlock"];
      this.coinsLimit = _data["coinsLimit"];
      if (Array.isArray(_data["methods"])) {
        this.methods = [] as any;
        for (let item of _data["methods"])
          this.methods!.push(MethodModel.fromJS(item));
      }
      this.id = _data["id"];
      this.profileId = _data["profileId"];
      this.hashAddress = _data["hashAddress"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.isFavorite = _data["isFavorite"];
      this.isSigned = _data["isSigned"];
      this.isConfirmed = _data["isConfirmed"];
    }
  }

  static fromJS(data: any): SmartContractDetailResult {
    data = typeof data === 'object' ? data : {};
    let result = new SmartContractDetailResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["creator"] = this.creator;
    data["consiliumName"] = this.consiliumName;
    data["consiliumId"] = this.consiliumId;
    data["consiliumIdInCil"] = this.consiliumIdInCil;
    data["fileName"] = this.fileName;
    data["fileHash"] = this.fileHash;
    data["txEthereum"] = this.txEthereum;
    data["txCil"] = this.txCil;
    data["genesisBlock"] = this.genesisBlock;
    data["coinsLimit"] = this.coinsLimit;
    if (Array.isArray(this.methods)) {
      data["methods"] = [];
      for (let item of this.methods)
        data["methods"].push(item.toJSON());
    }
    data["id"] = this.id;
    data["profileId"] = this.profileId;
    data["hashAddress"] = this.hashAddress;
    data["name"] = this.name;
    data["description"] = this.description;
    data["isFavorite"] = this.isFavorite;
    data["isSigned"] = this.isSigned;
    data["isConfirmed"] = this.isConfirmed;
    return data;
  }
}

export interface ISmartContractDetailResult {
  creator?: string | undefined;
  consiliumName?: string | undefined;
  consiliumId?: number | undefined;
  consiliumIdInCil?: number | undefined;
  fileName?: string | undefined;
  fileHash?: string | undefined;
  txEthereum?: string | undefined;
  txCil?: string | undefined;
  genesisBlock?: string | undefined;
  coinsLimit: number | undefined;
  methods?: MethodModel[] | undefined;
  id?: number | undefined;
  profileId?: number | undefined;
  hashAddress?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  isFavorite?: boolean | undefined;
  isSigned?: boolean | undefined;
  isConfirmed?: boolean | undefined;
}

export class MethodModel implements IMethodModel {
  name?: string | undefined;
  description?: string | undefined;
  coinsLimit?: number | undefined;
  amountFix?: number | undefined;
  amountMin?: number | undefined;
  amountMax?: number | undefined;
  parameters?: ParameterModel[] | undefined;

  constructor(data?: IMethodModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.description = _data["description"];
      this.coinsLimit = _data["coinsLimit"];
      this.amountFix = _data["amountFix"];
      this.amountMin = _data["amountMin"];
      this.amountMax = _data["amountMax"];
      if (Array.isArray(_data["parameters"])) {
        this.parameters = [] as any;
        for (let item of _data["parameters"])
          this.parameters!.push(ParameterModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MethodModel {
    data = typeof data === 'object' ? data : {};
    let result = new MethodModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["description"] = this.description;
    data["coinsLimit"] = this.coinsLimit;
    data["amountFix"] = this.amountFix;
    data["amountMin"] = this.amountMin;
    data["amountMax"] = this.amountMax;
    if (Array.isArray(this.parameters)) {
      data["parameters"] = [];
      for (let item of this.parameters)
        data["parameters"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMethodModel {
  name?: string | undefined;
  description?: string | undefined;
  coinsLimit?: number | undefined;
  amountFix?: number | undefined;
  amountMin?: number | undefined;
  amountMax?: number | undefined;
  parameters?: ParameterModel[] | undefined;
}

export class ParameterModel implements IParameterModel {
  name?: string | undefined;
  description?: string | undefined;
  dataType?: SmartContractMethodParamsDataType | undefined;

  constructor(data?: IParameterModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.description = _data["description"];
      this.dataType = _data["dataType"];
    }
  }

  static fromJS(data: any): ParameterModel {
    data = typeof data === 'object' ? data : {};
    let result = new ParameterModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["description"] = this.description;
    data["dataType"] = this.dataType;
    return data;
  }
}

export interface IParameterModel {
  name?: string | undefined;
  description?: string | undefined;
  dataType?: SmartContractMethodParamsDataType | undefined;
}

export class WalletSwapStatusQueryResult implements IWalletSwapStatusQueryResult {
  transitWallet?: string | undefined;
  status?: string | undefined;
  statusDate?: Date | undefined;

  constructor(data?: IWalletSwapStatusQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transitWallet = _data["transitWallet"];
      this.status = _data["status"];
      this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): WalletSwapStatusQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new WalletSwapStatusQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["transitWallet"] = this.transitWallet;
    data["status"] = this.status;
    data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IWalletSwapStatusQueryResult {
  transitWallet?: string | undefined;
  status?: string | undefined;
  statusDate?: Date | undefined;
}

export class CheckSwapAddressResult {
  exist: boolean;
  coinFrom?: string | undefined;
  coinTo?: string | undefined;
  tokenFrom?: string | undefined;
  tokenTo?: string | undefined;
  createDate?: string | undefined;
  createdLess24h?: boolean | undefined;
  lastStatusDate?: string | undefined;
  lastStatus?: number | undefined;

  constructor(data?: CheckSwapAddressResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.exist = _data["exist"];
      this.coinFrom = _data["coinFrom"];
      this.coinTo = _data["coinTo"];
      this.tokenFrom = _data["tokenFrom"];
      this.tokenTo = _data["tokenTo"];
      this.createDate = _data["createDate"];
      this.createdLess24h = _data["createdLess24h"];
      this.lastStatusDate = _data["lastStatusDate"];
      this.lastStatus = _data["lastStatus"];
    }
  }

  static fromJS(data: any): CheckSwapAddressResult {
    data = typeof data === 'object' ? data : {};
    let result = new CheckSwapAddressResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["exist"] = this.exist;
    data["coinFrom"] = this.coinFrom;
    data["coinTo"] = this.coinTo;
    data["tokenFrom"] = this.tokenFrom;
    data["tokenTo"] = this.tokenTo;
    data["createDate"] = this.createDate;
    data["createdLess24h"] = this.createdLess24h;
    data["lastStatusDate"] = this.lastStatusDate;
    data["lastStatus"] = this.lastStatus;
    return data;
  }
}

export class SwapRateResult implements ISwapRateResult {
  rate?: number | undefined;
  minAmount?: number | undefined;
  fee?: number | undefined;
  minAmountWithFee?: number | undefined;

  constructor(data?: ISwapRateResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rate = _data["rate"];
      this.minAmount = _data["minAmount"];
      this.fee = parseFloat(_data["fee"]);
      this.minAmountWithFee = parseFloat(_data["minAmountWithFee"]);
    }
  }

  static fromJS(data: any): SwapRateResult {
    data = typeof data === 'object' ? data : {};
    let result = new SwapRateResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rate"] = this.rate;
    data["minAmount"] = this.minAmount;
    data["fee"] = this.fee;
    data["minAmountWithFee"] = this.minAmountWithFee;
    return data;
  }
}

export interface ISwapRateResult {
  rate?: number | undefined;
  minAmount?: number | undefined;
  fee?: number | undefined;
  minAmountWithFee?: number | undefined;
}

export class UniswapResult implements IUniswapResult {
  tokenAmount?: number | undefined;
  ethAmount?: number | undefined;

  constructor(data?: IUniswapResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tokenAmount = _data["tokenAmount"];
      this.ethAmount = _data["ethAmount"];
    }
  }

  static fromJS(data: any): UniswapResult {
    data = typeof data === 'object' ? data : {};
    let result = new UniswapResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tokenAmount"] = this.tokenAmount;
    data["ethAmount"] = this.ethAmount;
    return data;
  }
}

export interface IUniswapResult {
  tokenAmount?: number | undefined;
  ethAmount?: number | undefined;
}

export class MultipleQueryResultOfTokenQueryResult implements IMultipleQueryResultOfTokenQueryResult {
  count?: number | undefined;
  data?: TokenQueryResult[] | undefined;

  constructor(data?: IMultipleQueryResultOfTokenQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(TokenQueryResult.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MultipleQueryResultOfTokenQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new MultipleQueryResultOfTokenQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMultipleQueryResultOfTokenQueryResult {
  count?: number | undefined;
  data?: TokenQueryResult[] | undefined;
}

export class TokenQueryResult implements ITokenQueryResult {
  id?: number | undefined;
  symbol?: string | undefined;
  decimal?: number | undefined;
  name?: string | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;
  balance?: number | undefined;
  logo?: string | undefined;
  swapTokenSymbol?: string | undefined;

  constructor(data?: ITokenQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.symbol = _data["symbol"];
      this.decimal = _data["decimal"];
      this.name = _data["name"];
      this.hashAddress = _data["hashAddress"];
      this.isHide = _data["isHide"];
      this.balance = _data["balance"];
      this.logo = _data["logo"];
      this.swapTokenSymbol = _data["swapTokenSymbol"];
    }
  }

  static fromJS(data: any): TokenQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new TokenQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["symbol"] = this.symbol;
    data["decimal"] = this.decimal;
    data["name"] = this.name;
    data["hashAddress"] = this.hashAddress;
    data["isHide"] = this.isHide;
    data["balance"] = this.balance;
    data["logo"] = this.logo;
    data["swapTokenSymbol"] = this.swapTokenSymbol;
    return data;
  }
}

export interface ITokenQueryResult {
  id?: number | undefined;
  symbol?: string | undefined;
  decimal?: number | undefined;
  name?: string | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;
  balance?: number | undefined;
  logo?: string | undefined;
  swapTokenSymbol?: string | undefined;
}

export class MetaQueryResultOfTokenQueryResult implements IMetaQueryResultOfTokenQueryResult {
  meta?: Metadata | undefined;
  count?: number | undefined;
  data?: TokenQueryResult[] | undefined;

  constructor(data?: IMetaQueryResultOfTokenQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.meta = _data["meta"] ? Metadata.fromJS(_data["meta"]) : <any>undefined;
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(TokenQueryResult.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MetaQueryResultOfTokenQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new MetaQueryResultOfTokenQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMetaQueryResultOfTokenQueryResult {
  meta?: Metadata | undefined;
  count?: number | undefined;
  data?: TokenQueryResult[] | undefined;
}

export class Metadata implements IMetadata {
  page?: number | undefined;
  perPage?: number | undefined;
  totalItems?: number | undefined;

  constructor(data?: IMetadata) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data["page"];
      this.perPage = _data["perPage"];
      this.totalItems = _data["totalItems"];
    }
  }

  static fromJS(data: any): Metadata {
    data = typeof data === 'object' ? data : {};
    let result = new Metadata();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["page"] = this.page;
    data["perPage"] = this.perPage;
    data["totalItems"] = this.totalItems;
    return data;
  }
}

export interface IMetadata {
  page?: number | undefined;
  perPage?: number | undefined;
  totalItems?: number | undefined;
}

export class SingleQueryResultOfToken implements ISingleQueryResultOfToken {
  data?: Token | undefined;

  constructor(data?: ISingleQueryResultOfToken) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.data = _data["data"] ? Token.fromJS(_data["data"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SingleQueryResultOfToken {
    data = typeof data === 'object' ? data : {};
    let result = new SingleQueryResultOfToken();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISingleQueryResultOfToken {
  data?: Token | undefined;
}

export class Token implements IToken {
  profileId?: number | undefined;
  walletId?: number | undefined;
  userId?: string | undefined;
  name?: string | undefined;
  symbol?: string | undefined;
  decimal?: number | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;
  createDate?: Date | undefined;
  wallet?: Wallet | undefined;
  id?: number | undefined;

  constructor(data?: IToken) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.walletId = _data["walletId"];
      this.userId = _data["userId"];
      this.name = _data["name"];
      this.symbol = _data["symbol"];
      this.decimal = _data["decimal"];
      this.hashAddress = _data["hashAddress"];
      this.isHide = _data["isHide"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.wallet = _data["wallet"] ? Wallet.fromJS(_data["wallet"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Token {
    data = typeof data === 'object' ? data : {};
    let result = new Token();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["walletId"] = this.walletId;
    data["userId"] = this.userId;
    data["name"] = this.name;
    data["symbol"] = this.symbol;
    data["decimal"] = this.decimal;
    data["hashAddress"] = this.hashAddress;
    data["isHide"] = this.isHide;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["wallet"] = this.wallet ? this.wallet.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface IToken {
  profileId?: number | undefined;
  walletId?: number | undefined;
  userId?: string | undefined;
  name?: string | undefined;
  symbol?: string | undefined;
  decimal?: number | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;
  createDate?: Date | undefined;
  wallet?: Wallet | undefined;
  id?: number | undefined;
}

export class Wallet implements IWallet {
  profileId?: number | undefined;
  userId?: string | undefined;
  coinType?: WalletCoinType | undefined;
  name?: string | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;
  createDate?: Date | undefined;
  forgotten?: Date | undefined;
  transactions?: Transaction[] | undefined;
  tokens?: Token[] | undefined;
  walletSwaps?: WalletSwap[] | undefined;
  id?: number | undefined;

  constructor(data?: IWallet) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.userId = _data["userId"];
      this.coinType = _data["coinType"];
      this.name = _data["name"];
      this.hashAddress = _data["hashAddress"];
      this.isHide = _data["isHide"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.forgotten = _data["forgotten"] ? new Date(_data["forgotten"].toString()) : <any>undefined;
      if (Array.isArray(_data["transactions"])) {
        this.transactions = [] as any;
        for (let item of _data["transactions"])
          this.transactions!.push(Transaction.fromJS(item));
      }
      if (Array.isArray(_data["tokens"])) {
        this.tokens = [] as any;
        for (let item of _data["tokens"])
          this.tokens!.push(Token.fromJS(item));
      }
      if (Array.isArray(_data["walletSwaps"])) {
        this.walletSwaps = [] as any;
        for (let item of _data["walletSwaps"])
          this.walletSwaps!.push(WalletSwap.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Wallet {
    data = typeof data === 'object' ? data : {};
    let result = new Wallet();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["userId"] = this.userId;
    data["coinType"] = this.coinType;
    data["name"] = this.name;
    data["hashAddress"] = this.hashAddress;
    data["isHide"] = this.isHide;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["forgotten"] = this.forgotten ? this.forgotten.toISOString() : <any>undefined;
    if (Array.isArray(this.transactions)) {
      data["transactions"] = [];
      for (let item of this.transactions)
        data["transactions"].push(item.toJSON());
    }
    if (Array.isArray(this.tokens)) {
      data["tokens"] = [];
      for (let item of this.tokens)
        data["tokens"].push(item.toJSON());
    }
    if (Array.isArray(this.walletSwaps)) {
      data["walletSwaps"] = [];
      for (let item of this.walletSwaps)
        data["walletSwaps"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IWallet {
  profileId?: number | undefined;
  userId?: string | undefined;
  coinType?: WalletCoinType | undefined;
  name?: string | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;
  createDate?: Date | undefined;
  forgotten?: Date | undefined;
  transactions?: Transaction[] | undefined;
  tokens?: Token[] | undefined;
  walletSwaps?: WalletSwap[] | undefined;
  id?: number | undefined;
}

export class Transaction implements ITransaction {
  walletId?: number | undefined;
  amount?: number | undefined;
  gasPrice?: number | undefined;
  destHashAddress?: string | undefined;
  srcHashAddress?: string | undefined;
  createDate?: Date | undefined;
  wallet?: Wallet | undefined;
  id?: number | undefined;

  constructor(data?: ITransaction) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.walletId = _data["walletId"];
      this.amount = _data["amount"];
      this.gasPrice = _data["gasPrice"];
      this.destHashAddress = _data["destHashAddress"];
      this.srcHashAddress = _data["srcHashAddress"];
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.wallet = _data["wallet"] ? Wallet.fromJS(_data["wallet"]) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Transaction {
    data = typeof data === 'object' ? data : {};
    let result = new Transaction();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["walletId"] = this.walletId;
    data["amount"] = this.amount;
    data["gasPrice"] = this.gasPrice;
    data["destHashAddress"] = this.destHashAddress;
    data["srcHashAddress"] = this.srcHashAddress;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["wallet"] = this.wallet ? this.wallet.toJSON() : <any>undefined;
    data["id"] = this.id;
    return data;
  }
}

export interface ITransaction {
  walletId?: number | undefined;
  amount?: number | undefined;
  gasPrice?: number | undefined;
  destHashAddress?: string | undefined;
  srcHashAddress?: string | undefined;
  createDate?: Date | undefined;
  wallet?: Wallet | undefined;
  id?: number | undefined;
}

export class WalletSwap implements IWalletSwap {
  transitWallet?: string | undefined;
  walletId?: number | undefined;
  wallet?: Wallet | undefined;
  walletSwapHistories?: WalletSwapHistory[] | undefined;
  id?: number | undefined;

  constructor(data?: IWalletSwap) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transitWallet = _data["transitWallet"];
      this.walletId = _data["walletId"];
      this.wallet = _data["wallet"] ? Wallet.fromJS(_data["wallet"]) : <any>undefined;
      if (Array.isArray(_data["walletSwapHistories"])) {
        this.walletSwapHistories = [] as any;
        for (let item of _data["walletSwapHistories"])
          this.walletSwapHistories!.push(WalletSwapHistory.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): WalletSwap {
    data = typeof data === 'object' ? data : {};
    let result = new WalletSwap();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["transitWallet"] = this.transitWallet;
    data["walletId"] = this.walletId;
    data["wallet"] = this.wallet ? this.wallet.toJSON() : <any>undefined;
    if (Array.isArray(this.walletSwapHistories)) {
      data["walletSwapHistories"] = [];
      for (let item of this.walletSwapHistories)
        data["walletSwapHistories"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IWalletSwap {
  transitWallet?: string | undefined;
  walletId?: number | undefined;
  wallet?: Wallet | undefined;
  walletSwapHistories?: WalletSwapHistory[] | undefined;
  id?: number | undefined;
}

export class WalletSwapHistory implements IWalletSwapHistory {
  walletSwapId?: number | undefined;
  walletSwap?: WalletSwap | undefined;
  createDate?: Date | undefined;
  status?: WalletSwapHistoryStatus | undefined;
  id?: number | undefined;

  constructor(data?: IWalletSwapHistory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.walletSwapId = _data["walletSwapId"];
      this.walletSwap = _data["walletSwap"] ? WalletSwap.fromJS(_data["walletSwap"]) : <any>undefined;
      this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
      this.status = _data["status"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): WalletSwapHistory {
    data = typeof data === 'object' ? data : {};
    let result = new WalletSwapHistory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["walletSwapId"] = this.walletSwapId;
    data["walletSwap"] = this.walletSwap ? this.walletSwap.toJSON() : <any>undefined;
    data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data["status"] = this.status;
    data["id"] = this.id;
    return data;
  }
}

export interface IWalletSwapHistory {
  walletSwapId?: number | undefined;
  walletSwap?: WalletSwap | undefined;
  createDate?: Date | undefined;
  status?: WalletSwapHistoryStatus | undefined;
  id?: number | undefined;
}

export class TokenDetailResult implements ITokenDetailResult {
  name?: string | undefined;
  symbol?: string | undefined;
  decimal?: number | undefined;
  hashAddress?: string | undefined;
  coinType?: TokenDetailResultCoinType | undefined;
  walletAddress?: string | undefined;
  consiliumIdInCil?: number | undefined;

  constructor(data?: ITokenDetailResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.symbol = _data["symbol"];
      this.decimal = _data["decimal"];
      this.hashAddress = _data["hashAddress"];
      this.coinType = _data["coinType"];
      this.walletAddress = _data["walletAddress"];
      this.consiliumIdInCil = _data["consiliumIdInCil"];
    }
  }

  static fromJS(data: any): TokenDetailResult {
    data = typeof data === 'object' ? data : {};
    let result = new TokenDetailResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["symbol"] = this.symbol;
    data["decimal"] = this.decimal;
    data["hashAddress"] = this.hashAddress;
    data["coinType"] = this.coinType;
    data["walletAddress"] = this.walletAddress;
    data["consiliumIdInCil"] = this.consiliumIdInCil;
    return data;
  }
}

export interface ITokenDetailResult {
  name?: string | undefined;
  symbol?: string | undefined;
  decimal?: number | undefined;
  hashAddress?: string | undefined;
  coinType?: TokenDetailResultCoinType | undefined;
  walletAddress?: string | undefined;
  consiliumIdInCil?: number | undefined;
}

/** Token model */
export class TokenViewModel implements ITokenViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Wallet id */
  walletId?: number | undefined;
  /** Token name */
  name?: string | undefined;
  /** Token symbol */
  symbol?: string | undefined;
  /** Token decimal */
  decimal?: number | undefined;
  /** Token hash */
  hashAddress?: string | undefined;

  constructor(data?: ITokenViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.walletId = _data["walletId"];
      this.name = _data["name"];
      this.symbol = _data["symbol"];
      this.decimal = _data["decimal"];
      this.hashAddress = _data["hashAddress"];
    }
  }

  static fromJS(data: any): TokenViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new TokenViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["walletId"] = this.walletId;
    data["name"] = this.name;
    data["symbol"] = this.symbol;
    data["decimal"] = this.decimal;
    data["hashAddress"] = this.hashAddress;
    return data;
  }
}

/** Token model */
export interface ITokenViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Wallet id */
  walletId?: number | undefined;
  /** Token name */
  name?: string | undefined;
  /** Token symbol */
  symbol?: string | undefined;
  /** Token decimal */
  decimal?: number | undefined;
  /** Token hash */
  hashAddress?: string | undefined;
}

/** Change token visibility */
export class ChangeDisplayStatusTokenViewModel implements IChangeDisplayStatusTokenViewModel {
  /** Wallet id */
  walletId?: number | undefined;
  /** Token id */
  tokenId?: number | undefined;
  /** Action type */
  isHide?: boolean | undefined;

  constructor(data?: IChangeDisplayStatusTokenViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.walletId = _data["walletId"];
      this.tokenId = _data["tokenId"];
      this.isHide = _data["isHide"];
    }
  }

  static fromJS(data: any): ChangeDisplayStatusTokenViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeDisplayStatusTokenViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["walletId"] = this.walletId;
    data["tokenId"] = this.tokenId;
    data["isHide"] = this.isHide;
    return data;
  }
}

/** Change token visibility */
export interface IChangeDisplayStatusTokenViewModel {
  /** Wallet id */
  walletId?: number | undefined;
  /** Token id */
  tokenId?: number | undefined;
  /** Action type */
  isHide?: boolean | undefined;
}

export class CheckTokenNameQueryResult implements ICheckTokenNameQueryResult {
  readonly isExist?: boolean | undefined;

  constructor(data?: ICheckTokenNameQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).isExist = _data["isExist"];
    }
  }

  static fromJS(data: any): CheckTokenNameQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new CheckTokenNameQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isExist"] = this.isExist;
    return data;
  }
}

export interface ICheckTokenNameQueryResult {
  isExist?: boolean | undefined;
}

export class TokenHoldersResult implements ITokenHoldersResult {
  items?: HolderModel[] | undefined;

  constructor(data?: ITokenHoldersResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(HolderModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TokenHoldersResult {
    data = typeof data === 'object' ? data : {};
    let result = new TokenHoldersResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface ITokenHoldersResult {
  items?: HolderModel[] | undefined;
}

export class HolderModel implements IHolderModel {
  profileId?: number | undefined;
  walletAddress?: string | undefined;
  amount?: number | undefined;

  constructor(data?: IHolderModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.walletAddress = _data["walletAddress"];
      this.amount = _data["amount"];
    }
  }

  static fromJS(data: any): HolderModel {
    data = typeof data === 'object' ? data : {};
    let result = new HolderModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["walletAddress"] = this.walletAddress;
    data["amount"] = this.amount;
    return data;
  }
}

export interface IHolderModel {
  profileId?: number | undefined;
  walletAddress?: string | undefined;
  amount?: number | undefined;
}

export class MultipleQueryResultOfWalletQueryResult implements IMultipleQueryResultOfWalletQueryResult {
  count?: number | undefined;
  data?: WalletQueryResult[] | undefined;

  constructor(data?: IMultipleQueryResultOfWalletQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(WalletQueryResult.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MultipleQueryResultOfWalletQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new MultipleQueryResultOfWalletQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["count"] = this.count;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMultipleQueryResultOfWalletQueryResult {
  count?: number | undefined;
  data?: WalletQueryResult[] | undefined;
}

export class WalletQueryResult implements IWalletQueryResult {
  id?: number | undefined;
  coinType?: WalletQueryResultCoinType | undefined;
  name?: string | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;

  constructor(data?: IWalletQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.coinType = _data["coinType"];
      this.name = _data["name"];
      this.hashAddress = _data["hashAddress"];
      this.isHide = _data["isHide"];
    }
  }

  static fromJS(data: any): WalletQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new WalletQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["coinType"] = this.coinType;
    data["name"] = this.name;
    data["hashAddress"] = this.hashAddress;
    data["isHide"] = this.isHide;
    return data;
  }
}

export interface IWalletQueryResult {
  id?: number | undefined;
  coinType?: WalletQueryResultCoinType | undefined;
  name?: string | undefined;
  hashAddress?: string | undefined;
  isHide?: boolean | undefined;
}

/** Wallet model */
export class WalletViewModel implements IWalletViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Coint type */
  coinType?: WalletViewModelCoinType | undefined;
  /** Wallet name */
  name?: string | undefined;
  /** Wallet hash */
  hashAddress?: string | undefined;

  constructor(data?: IWalletViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.coinType = _data["coinType"];
      this.name = _data["name"];
      this.hashAddress = _data["hashAddress"];
    }
  }

  static fromJS(data: any): WalletViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new WalletViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["coinType"] = this.coinType;
    data["name"] = this.name;
    data["hashAddress"] = this.hashAddress;
    return data;
  }
}

/** Wallet model */
export interface IWalletViewModel {
  /** Profile id */
  profileId?: number | undefined;
  /** Coint type */
  coinType?: WalletViewModelCoinType | undefined;
  /** Wallet name */
  name?: string | undefined;
  /** Wallet hash */
  hashAddress?: string | undefined;
}

/** Change wallet visibility */
export class ChangeDisplayStatusWalletViewModel implements IChangeDisplayStatusWalletViewModel {
  /** Wallet id */
  walletId?: number | undefined;
  /** Action type */
  isHide?: boolean | undefined;

  constructor(data?: IChangeDisplayStatusWalletViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.walletId = _data["walletId"];
      this.isHide = _data["isHide"];
    }
  }

  static fromJS(data: any): ChangeDisplayStatusWalletViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeDisplayStatusWalletViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["walletId"] = this.walletId;
    data["isHide"] = this.isHide;
    return data;
  }
}

/** Change wallet visibility */
export interface IChangeDisplayStatusWalletViewModel {
  /** Wallet id */
  walletId?: number | undefined;
  /** Action type */
  isHide?: boolean | undefined;
}

export class SingleQueryResultOfWallet implements ISingleQueryResultOfWallet {
  data?: Wallet | undefined;

  constructor(data?: ISingleQueryResultOfWallet) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.data = _data["data"] ? Wallet.fromJS(_data["data"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SingleQueryResultOfWallet {
    data = typeof data === 'object' ? data : {};
    let result = new SingleQueryResultOfWallet();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISingleQueryResultOfWallet {
  data?: Wallet | undefined;
}

export class NextWalletNumberQueryResult implements INextWalletNumberQueryResult {
  readonly number?: string | undefined;

  constructor(data?: INextWalletNumberQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).number = _data["number"];
    }
  }

  static fromJS(data: any): NextWalletNumberQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new NextWalletNumberQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["number"] = this.number;
    return data;
  }
}

export interface INextWalletNumberQueryResult {
  number?: string | undefined;
}

export class CheckWalletNameQueryResult implements ICheckWalletNameQueryResult {
  readonly isExist?: boolean | undefined;

  constructor(data?: ICheckWalletNameQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).isExist = _data["isExist"];
    }
  }

  static fromJS(data: any): CheckWalletNameQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new CheckWalletNameQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isExist"] = this.isExist;
    return data;
  }
}

export interface ICheckWalletNameQueryResult {
  isExist?: boolean | undefined;
}

/** Rename wallet request model */
export class RenameWalletRequest implements IRenameWalletRequest {
  /** Wallet id */
  walletId?: number | undefined;
  /** Wallet name */
  name?: string | undefined;

  constructor(data?: IRenameWalletRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.walletId = _data["walletId"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): RenameWalletRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RenameWalletRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["walletId"] = this.walletId;
    data["name"] = this.name;
    return data;
  }
}

/** Rename wallet request model */
export interface IRenameWalletRequest {
  /** Wallet id */
  walletId?: number | undefined;
  /** Wallet name */
  name?: string | undefined;
}

export class LawWalletsListQueryResult implements ILawWalletsListQueryResult {
  data?: LawWallets[] | undefined;

  constructor(data?: ILawWalletsListQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(LawWallets.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LawWalletsListQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new LawWalletsListQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ILawWalletsListQueryResult {
  data?: LawWallets[] | undefined;
}

export class LawWallets implements ILawWallets {
  profileId?: number | undefined;
  walletAddress?: string | undefined;

  constructor(data?: ILawWallets) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data["profileId"];
      this.walletAddress = _data["walletAddress"];
    }
  }

  static fromJS(data: any): LawWallets {
    data = typeof data === 'object' ? data : {};
    let result = new LawWallets();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["profileId"] = this.profileId;
    data["walletAddress"] = this.walletAddress;
    return data;
  }
}

export interface ILawWallets {
  profileId?: number | undefined;
  walletAddress?: string | undefined;
}

/** Wallet key store */
export class WalletKeyViewModel implements IWalletKeyViewModel {
  fileName?: string | undefined;
  keyFile?: string | undefined;
  email?: string | undefined;

  constructor(data?: IWalletKeyViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileName = _data["fileName"];
      this.keyFile = _data["keyFile"];
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): WalletKeyViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new WalletKeyViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fileName"] = this.fileName;
    data["keyFile"] = this.keyFile;
    data["email"] = this.email;
    return data;
  }
}

/** Wallet key store */
export interface IWalletKeyViewModel {
  fileName?: string | undefined;
  keyFile?: string | undefined;
  email?: string | undefined;
}

export class AirdropRewardsResult implements IAirdropRewardsResult {
  data?: AirdropRewardDto[] | undefined;
  count?: number;
  total?: number;

  constructor(data?: IAirdropRewardsResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(AirdropRewardDto.fromJS(item));
      }
      this.count = _data["count"];
      this.total = _data["total"];
    }
  }

  static fromJS(data: any): AirdropRewardsResult {
    data = typeof data === 'object' ? data : {};
    let result = new AirdropRewardsResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item.toJSON());
    }
    data["count"] = this.count;
    data["total"] = this.total;
    return data;
  }
}

export interface IAirdropRewardsResult {
  data?: AirdropRewardDto[] | undefined;
  count?: number;
  total?: number;
}

export class AirdropRewardDto implements IAirdropRewardDto {
  referralEmail?: string | undefined;
  address?: string | undefined;
  reward?: number;

  constructor(data?: IAirdropRewardDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referralEmail = _data["referralEmail"];
      this.address = _data["address"];
      this.reward = _data["reward"];
    }
  }

  static fromJS(data: any): AirdropRewardDto {
    data = typeof data === 'object' ? data : {};
    let result = new AirdropRewardDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["referralEmail"] = this.referralEmail;
    data["address"] = this.address;
    data["reward"] = this.reward;
    return data;
  }
}

export interface IAirdropRewardDto {
  referralEmail?: string | undefined;
  address?: string | undefined;
  reward?: number;
}

/** Coin type */
export enum CoinType {
  Cil = "Cil",
  Eth = "Eth",
}

export enum CoinType2 {
  Cil = "Cil",
  Eth = "Eth",
}

/** Coin type */
export enum CoinType3 {
  Cil = "Cil",
  Eth = "Eth",
}

/** Coin type */
export enum CoinType4 {
  Cil = "Cil",
  Eth = "Eth",
}

/** Search type */
export enum SearchType {
  All = "All",
  CurrentProfile = "CurrentProfile",
  Favorite = "Favorite",
}

export enum PostSearchType {
  Actual = "Actual",
  Archive = "Archive",
  AllActual = "AllActual",
  New = "New",
  Commented = "Commented",
  AllArchive = "AllArchive",
}

/** Search type */
export enum GameSearchType {
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  Finished = "Finished",
  InProgress = "InProgress",
  Unknown = "Unknown",
}

/** Search type */
export enum SearchType2 {
  All = "All",
  CurrentProfile = "CurrentProfile",
  Favorite = "Favorite",
}

export enum Pref {
  Sntr2Law = "Sntr2Law",
  Eth2Law = "Eth2Law",
  Btc2Law = "Btc2Law",
  Eth2LawToken = "Eth2LawToken",
  EthToken2Law = "EthToken2Law",
  Law2EthToken = "Law2EthToken",
  LawToken2EthToken = "LawToken2EthToken",
  EthToken2LawToken = "EthToken2LawToken",
}


export enum Pref2 {
  Sntr2Law = "Sntr2Law",
  Eth2Law = "Eth2Law",
  Law2Eth = "Law2Eth",
  Btc2Law = "Btc2Law",
  Eth2LawToken = "Eth2LawToken",
  EthToken2Law = "EthToken2Law",
  Law2EthToken = "Law2EthToken",
  LawToken2EthToken = "LawToken2EthToken",
  EthToken2LawToken = "EthToken2LawToken",
  LawToken2Eth = "LawToken2Eth"
}

export enum Pref3 {
  Sntr2Law = "Sntr2Law",
  Eth2Law = "Eth2Law",
  Btc2Law = "Btc2Law",
  Eth2LawToken = "Eth2LawToken",
  EthToken2Law = "EthToken2Law",
  Law2EthToken = "Law2EthToken",
  LawToken2EthToken = "LawToken2EthToken",
  EthToken2LawToken = "EthToken2LawToken",
}

export enum Pref4 {
  Sntr2Law = "Sntr2Law",
  Eth2Law = "Eth2Law",
  Btc2Law = "Btc2Law",
  Eth2LawToken = "Eth2LawToken",
  EthToken2Law = "EthToken2Law",
  Law2EthToken = "Law2EthToken",
  LawToken2EthToken = "LawToken2EthToken",
  EthToken2LawToken = "EthToken2LawToken",
}

export enum Pref5 {
  Sntr2Law = "Sntr2Law",
  Eth2Law = "Eth2Law",
  Btc2Law = "Btc2Law",
  Eth2LawToken = "Eth2LawToken",
  EthToken2Law = "EthToken2Law",
  Law2EthToken = "Law2EthToken",
  LawToken2EthToken = "LawToken2EthToken",
  EthToken2LawToken = "EthToken2LawToken",
}

/** Coin Type */
export enum CoinType5 {
  Cil = "Cil",
  Eth = "Eth",
}

export enum CoinType6 {
  Cil = "Cil",
  Eth = "Eth",
}

export enum CoinType7 {
  Cil = "Cil",
  Eth = "Eth",
}

export enum ExceptCoinTypes {
  Cil = "Cil",
  Eth = "Eth",
}

export enum TransactionViewModelCoinType {
  Cil = "Cil",
  Eth = "Eth",
}

export enum TransactionFeeType {
  Slow = "Slow",
  Average = "Average",
  Fast = "Fast",
}

export enum AddToFavoriteViewModelFavoriteType {
  Favorite = "Favorite",
  Signed = "Signed",
}

export enum GameModelGameStatus {
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  Finished = "Finished",
  InProgress = "InProgress",
  Unknown = "Unknown",
}

export enum GameDetailResultGameStatus {
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  Finished = "Finished",
  InProgress = "InProgress",
  Unknown = "Unknown",
}

export enum WalletCoinType {
  Cil = "Cil",
  Eth = "Eth",
}


export enum SmartContractMethodParamsDataType {
  String = 0,
  Number = 1
}

export enum WalletSwapHistoryStatus {
  Created = "Created",
  Confirmed = "Confirmed",
  Cancelled = "Cancelled",
}

export enum TokenDetailResultCoinType {
  Cil = "Cil",
  Eth = "Eth",
}

export enum WalletQueryResultCoinType {
  Cil = "Cil",
  Eth = "Eth",
}

export enum WalletViewModelCoinType {
  Cil = "Cil",
  Eth = "Eth",
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}


// FOR SWAP STAT
export class CDRSwapStatRequest {
  fromAddress?: string | undefined;
  toAddress?: string | undefined;
  amount?: number;
  pair?: CDRSwapPair;
  fromUbikiri?: boolean | undefined;
  swapAddress?: string | undefined;
}

export class CDRSwapPair{
  fromCoin?: string | undefined;
  fromSymbol?: string | undefined;
  fromDisplayName?: string | undefined;
  toCoin?: string | undefined;
  toSymbol?: string | undefined;
  toDisplayName?: string | undefined;
  displayName?: string | undefined;
}


